<template>
  <div>
    <CrmToolbar>
      <div class="crm-funnel-toolbar">
        <div class="crm-funnel-selector">
          <label for="crm-funnel-select">Funil</label>
          <b-form-select
            id="crm-funnel-select"
            :options="funilOptionsSemTodos"
            :value="funilAtualId"
            @change="selecionarFunilRapido"
          />
        </div>

        <div class="crm-quick-search">
          <label for="crm-funnel-quick-search">Busca rápida</label>
          <div class="crm-quick-search-input">
            <i class="la la-search"></i>
            <b-form-input
              id="crm-funnel-quick-search"
              v-model="filtros.busca"
              placeholder="Nome ou título do card"
              autocomplete="off"
              @input="debouncedLoadKanban"
            />
            <button
              v-if="filtros.busca"
              class="crm-quick-search-clear"
              type="button"
              title="Limpar busca"
              @click="limparBuscaRapida"
            >
              <i class="la la-times"></i>
            </button>
          </div>
        </div>

        <div class="crm-filter-bar">
          <button
            class="btn btn-light-primary btn-sm"
            type="button"
            @click="filtersDrawerVisible = true"
          >
            <i class="la la-filter"></i>
            Filtros
            <span v-if="activeFilterCount" class="crm-filter-count">
              {{ activeFilterCount }}
            </span>
          </button>
          <button
            class="btn btn-light btn-sm"
            type="button"
            @click="loadKanban"
          >
            Atualizar
          </button>
          <button
            v-if="activeFilterCount"
            class="btn btn-light btn-sm"
            type="button"
            @click="limparFiltros"
          >
            Limpar filtros
          </button>
          <button
            class="btn btn-dark btn-sm"
            type="button"
            @click="abrirModalCriacao()"
          >
            Nova oportunidade
          </button>
        </div>
      </div>
    </CrmToolbar>

    <CrmActiveFilters :filters="activeFilters" @remove="limparFiltroAtivo" />

    <b-sidebar
      v-model="filtersDrawerVisible"
      backdrop
      right
      shadow
      title="Filtros do funil"
      width="420px"
    >
      <div class="crm-filter-drawer">
        <b-form-group label="Funil">
          <b-form-select
            v-model="filtros.id_crm_funil"
            :options="funilOptions"
          />
        </b-form-group>
        <b-form-group label="Responsável">
          <b-form-select
            v-model="filtros.id_usuario"
            :options="usuarioOptions"
          />
        </b-form-group>
        <b-form-group label="Status">
          <b-form-select v-model="filtros.status" :options="statusOptions" />
        </b-form-group>
        <b-form-group label="Fonte do lead">
          <b-form-select
            v-model="filtros.id_crm_fonte"
            :options="fonteFiltroOptions"
          />
        </b-form-group>
        <b-form-group label="Temperatura">
          <b-form-select
            v-model="filtros.temperatura"
            :options="temperaturaFiltroOptions"
          />
        </b-form-group>
        <b-form-group label="Busca geral">
          <b-form-input
            v-model="filtros.busca"
            placeholder="Cliente, contato ou título"
            @input="debouncedLoadKanban"
          />
        </b-form-group>
        <b-form-group label="Busca em notas">
          <b-form-input
            v-model="filtros.busca_notas"
            placeholder="Palavra nas notas ou timeline"
          />
        </b-form-group>
        <b-form-group label="Próxima tarefa">
          <b-form-select
            v-model="filtros.periodo_atividade"
            :options="periodoAtividadeOptions"
          />
        </b-form-group>
        <b-row>
          <b-col md="6">
            <b-form-group label="Data inicial">
              <b-form-input v-model="filtros.data_inicio" type="date" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Data final">
              <b-form-input v-model="filtros.data_fim" type="date" />
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <template #footer>
        <div class="crm-drawer-footer">
          <button class="btn btn-light" type="button" @click="limparFiltros">
            Limpar
          </button>
          <button class="btn btn-dark" type="button" @click="aplicarFiltros">
            Aplicar filtros
          </button>
        </div>
      </template>
    </b-sidebar>

    <CrmEmptyState
      v-if="loading"
      title="Carregando funil..."
      description="Buscando oportunidades, valores e próximas ações."
      icon="la la-refresh"
    />

    <CrmEmptyState
      v-else-if="kanbanError"
      title="Acesso indisponível"
      :description="kanbanError"
      icon="la la-lock"
    />

    <div v-else-if="kanban" class="crm-kanban-shell">
      <div
        ref="kanbanTopScroll"
        class="crm-kanban-top-scroll"
        @scroll="sincronizarKanbanScroll('top')"
      >
        <div
          class="crm-kanban-scroll-content"
          :style="{ width: `${kanbanScrollWidth}px` }"
        ></div>
      </div>
      <div
        ref="kanbanScroll"
        class="crm-kanban"
        @scroll="sincronizarKanbanScroll('bottom')"
      >
        <div
          class="crm-kanban-column"
          :class="{
            'is-drop-target': colunaDropAtiva(coluna),
            'is-drop-source': colunaDragOrigem(coluna),
            'is-moving': dragState.moving,
          }"
          v-for="coluna in kanban.colunas"
          :key="coluna.etapa.id_crm_etapa"
          @dragenter.prevent="marcarColunaDrop(coluna)"
          @dragleave="limparColunaDrop(coluna, $event)"
          @dragover.prevent="marcarColunaDrop(coluna)"
          @drop.prevent="soltarOportunidade(coluna)"
        >
          <div class="crm-kanban-header">
            <div>
              <strong>{{ coluna.etapa.nome }}</strong>
              <div v-if="coluna.valor_total !== null" class="crm-kanban-value">
                {{ formatMoney(coluna.valor_total) }}
              </div>
              <small
                v-if="etapaAutomacaoResumo(coluna.etapa)"
                class="crm-stage-automation"
              >
                {{ etapaAutomacaoResumo(coluna.etapa) }}
              </small>
            </div>
            <span class="label label-inline label-light-primary">{{
              coluna.total
            }}</span>
          </div>

          <div v-if="colunaDropAtiva(coluna)" class="crm-drop-hint">
            Solte para mover para {{ coluna.etapa.nome }}
          </div>

          <CrmDealCard
            v-for="oportunidade in coluna.oportunidades"
            :key="oportunidade.id_crm_oportunidade"
            :dragging="oportunidadeEmDrag(oportunidade)"
            :draggable="oportunidade.status === 'aberta' && !dragState.moving"
            :oportunidade="oportunidade"
            :temperature-options="temperaturaOptions"
            @drag-end="encerrarDrag"
            @drag-start="iniciarDrag"
            @open="abrirDetalhe"
            @task="abrirModalTarefa"
            @schedule="abrirModalAgenda"
            @note="abrirModalNota"
            @more="abrirModalAcoes"
            @temperature="abrirModalTemperatura"
          />

          <CrmEmptyState
            v-if="coluna.oportunidades.length === 0"
            title="Nenhuma oportunidade"
            description="Crie uma oportunidade pelo botão acima dos filtros ou mova cards do funil."
            icon="la la-columns"
          />

          <button
            v-if="coluna.oportunidades.length < coluna.total"
            class="btn btn-light btn-sm btn-block mt-3"
            type="button"
            :disabled="loadingEtapas[coluna.etapa.id_crm_etapa]"
            @click="carregarMais(coluna)"
          >
            Carregar mais
          </button>
        </div>
      </div>
    </div>

    <b-modal
      id="crm-funil-oportunidade-modal"
      :title="modalTitle"
      hide-footer
      size="xl"
    >
      <div v-if="!form.id_crm_oportunidade" class="crm-wizard">
        <div class="crm-wizard-steps">
          <button
            v-for="(step, index) in wizardSteps"
            :key="step.key"
            class="crm-wizard-step"
            :class="{
              active: wizardStep === index,
              done: wizardStep > index,
            }"
            type="button"
            @click="irParaWizardStep(index)"
          >
            <span>{{ index + 1 }}</span>
            <strong>{{ step.label }}</strong>
          </button>
        </div>

        <div class="crm-wizard-body">
          <section class="crm-wizard-main">
            <div v-if="wizardStep === 0">
              <h3>Nome da negociação</h3>
              <p>Use um nome curto e fácil de reconhecer no funil.</p>
              <b-form-group label="Título da oportunidade">
                <b-form-input
                  v-model="form.titulo"
                  autofocus
                  maxlength="140"
                  placeholder="Ex.: Venda balcão - Maria Silva"
                />
              </b-form-group>
            </div>

            <div v-else-if="wizardStep === 1">
              <h3>Cliente ou contato</h3>
              <p>
                Busque um cadastro existente ou crie um contato rápido com
                WhatsApp.
              </p>
              <BuscaClienteContato
                v-model="vinculoSelecionado"
                label="Cliente ou contato"
                @criar-contato="criarContatoRapido"
              />
            </div>

            <div v-else-if="wizardStep === 2">
              <h3>Dados comerciais</h3>
              <p>
                Escolha o funil e informe os dados iniciais. A oportunidade
                entra na primeira etapa ativa.
              </p>
              <b-row>
                <b-col md="6">
                  <b-form-group label="Funil">
                    <b-form-select
                      v-model="form.id_crm_funil"
                      :options="funilOptionsSemTodos"
                      @change="form.id_crm_etapa = null"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <div class="crm-stage-preview">
                    <span>Etapa inicial</span>
                    <strong>{{ etapaInicialLabel(form.id_crm_funil) }}</strong>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group label="Valor estimado">
                    <money
                      class="form-control"
                      v-model="form.valor_estimado"
                      v-bind="priceOptions"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Responsável">
                    <b-form-select
                      v-model="form.id_usuario"
                      :options="usuarioOptionsSemTodos"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group label="Fonte do lead">
                    <b-form-select
                      v-model="form.id_crm_fonte"
                      :options="fonteOptions"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Campanha">
                    <b-form-input
                      v-model="form.campanha"
                      maxlength="120"
                      placeholder="Ex.: Google Ads, indicação, feira"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group label="Previsão de fechamento">
                    <b-form-input
                      v-model="form.previsao_fechamento"
                      type="date"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Próxima ação">
                    <b-form-input
                      v-model="form.proxima_atividade_em"
                      type="datetime-local"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Temperatura/qualificação">
                    <b-form-select
                      v-model="form.temperatura"
                      :options="temperaturaOptions"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div v-else>
              <h3>Confirmar criação</h3>
              <p>Revise os principais dados antes de mandar para o funil.</p>
              <div class="crm-wizard-summary">
                <div>
                  <span>Negociação</span>
                  <strong>{{ form.titulo || "Sem título" }}</strong>
                </div>
                <div>
                  <span>Cliente ou contato</span>
                  <strong>{{ vinculoSelecionadoLabel }}</strong>
                </div>
                <div>
                  <span>Funil e etapa</span>
                  <strong>{{ wizardFunilEtapaLabel }}</strong>
                </div>
                <div>
                  <span>Valor</span>
                  <strong>{{ formatMoney(form.valor_estimado) }}</strong>
                </div>
                <div>
                  <span>Origem</span>
                  <strong>{{ wizardOrigemLabel }}</strong>
                </div>
              </div>
            </div>
          </section>

          <aside class="crm-wizard-preview">
            <small>Preview no funil</small>
            <CrmDealCard
              :draggable="false"
              :oportunidade="wizardPreviewOportunidade"
              :show-actions="false"
              :temperature-options="temperaturaOptions"
              @more="() => null"
              @note="() => null"
              @open="() => null"
              @schedule="() => null"
              @task="() => null"
            />
          </aside>
        </div>

        <div class="crm-wizard-footer">
          <button
            class="btn btn-light"
            type="button"
            @click="fecharCriacaoMaisTarde"
          >
            Criar mais tarde
          </button>
          <div>
            <button
              v-if="wizardStep > 0"
              class="btn btn-light mr-2"
              type="button"
              @click="wizardStep -= 1"
            >
              Voltar
            </button>
            <button
              v-if="wizardStep < wizardSteps.length - 1"
              class="btn btn-dark"
              type="button"
              @click="avancarWizard"
            >
              Próximo
            </button>
            <button
              v-else
              class="btn btn-light-primary mr-2"
              type="button"
              :disabled="savingOportunidade"
              @click="salvarOportunidade(true)"
            >
              Salvar e criar outra
            </button>
            <button
              v-if="wizardStep === wizardSteps.length - 1"
              class="btn btn-dark"
              type="button"
              :disabled="savingOportunidade"
              @click="salvarOportunidade(false)"
            >
              Criar oportunidade
            </button>
          </div>
        </div>
      </div>

      <div v-else>
        <b-form-group label="Título">
          <b-form-input v-model="form.titulo" maxlength="140" />
        </b-form-group>
        <b-row>
          <b-col md="6">
            <b-form-group label="Funil">
              <b-form-select
                v-model="form.id_crm_funil"
                :options="funilOptionsSemTodos"
                @change="form.id_crm_etapa = null"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Etapa">
              <b-form-select
                v-model="form.id_crm_etapa"
                :options="etapaOptions(form.id_crm_funil)"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="Valor estimado">
              <money
                class="form-control"
                v-model="form.valor_estimado"
                v-bind="priceOptions"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Responsável">
              <b-form-select
                v-model="form.id_usuario"
                :options="usuarioOptionsSemTodos"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="Previsão de fechamento">
              <b-form-input v-model="form.previsao_fechamento" type="date" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Próxima ação">
              <b-form-input
                v-model="form.proxima_atividade_em"
                type="datetime-local"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="Fonte do lead">
              <b-form-select
                v-model="form.id_crm_fonte"
                :options="fonteOptions"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Campanha">
              <b-form-input
                v-model="form.campanha"
                maxlength="120"
                placeholder="Ex.: Google Ads, indicação, feira"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-end">
          <button
            class="btn btn-light mr-2"
            type="button"
            @click="$bvModal.hide('crm-funil-oportunidade-modal')"
          >
            Cancelar
          </button>
          <button
            class="btn btn-dark"
            type="button"
            :disabled="savingOportunidade"
            @click="salvarOportunidade(false)"
          >
            Salvar
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="crm-mover-oportunidade-modal"
      title="Mover oportunidade"
      @ok.prevent="moverOportunidade"
    >
      <b-form-group label="Etapa de destino">
        <b-form-select
          v-model="idEtapaDestino"
          :options="etapaOptions(oportunidadeSelecionada.id_crm_funil)"
          @change="prepararCamposMovimento"
        />
      </b-form-group>
      <b-form-group
        v-if="movimentoExigeTecnico"
        label="Desenvolvedor da apresentação"
      >
        <b-form-select
          v-model="idUsuarioTecnicoDestino"
          :options="desenvolvedorResponsavelOptions"
        />
        <small class="text-muted">
          Este desenvolvedor assume a apresentação técnica e a implementação
          White Label.
        </small>
      </b-form-group>
      <b-form-group
        v-if="movimentoExigeAtribuicao"
        label="Vendedor responsável"
      >
        <b-form-select
          v-model="idUsuarioDestino"
          :options="vendedorResponsavelOptions"
        />
        <small class="text-muted">
          Este vendedor ficará vinculado ao card durante todo o fluxo comercial.
        </small>
        <b-form-checkbox
          v-if="usuarioDestinoSemAcesso"
          v-model="concederAcessoFunilDestino"
          class="mt-3"
        >
          Conceder acesso deste usuário ao funil atual
        </b-form-checkbox>
      </b-form-group>
      <div
        v-if="camposObrigatoriosMovimento.length"
        class="crm-move-requirements"
      >
        <b-alert show variant="warning" class="mb-4">
          Esta etapa exige informações antes de receber a oportunidade.
        </b-alert>
        <b-form-group
          v-if="movimentoExigeValorNegociacao"
          label="Valor negociado"
        >
          <b-form-radio-group
            v-model="movimentoManterValor"
            :options="[
              { value: true, text: 'Manter o valor já informado' },
              { value: false, text: 'Informar novo valor' },
            ]"
            stacked
            @change="prepararCamposMovimento"
          />
        </b-form-group>
        <b-form-group
          v-for="regra in camposObrigatoriosMovimento"
          :key="regra.id_crm_etapa_campo_obrigatorio"
          :label="labelCampoObrigatorio(regra)"
        >
          <b-form-select
            v-if="campoObrigatorioTipo(regra) === 'lista'"
            v-model="movimentoCamposForm[regra.id_crm_campo_comercial]"
            :options="campoObrigatorioOptions(regra)"
          />
          <b-form-textarea
            v-else-if="campoObrigatorioTipo(regra) === 'texto_longo'"
            v-model="movimentoCamposForm[regra.id_crm_campo_comercial]"
            rows="3"
          />
          <money
            v-else-if="
              campoObrigatorioTipo(regra) === 'numero' &&
              isCampoObrigatorioMonetario(regra)
            "
            v-model="movimentoCamposForm[regra.id_crm_campo_comercial]"
            class="form-control"
            v-bind="priceOptions"
            :disabled="
              movimentoManterValor &&
              campoObrigatorioChave(regra) === 'valor_negociacao'
            "
          />
          <b-form-input
            v-else-if="campoObrigatorioTipo(regra) === 'numero'"
            v-model="movimentoCamposForm[regra.id_crm_campo_comercial]"
            type="number"
            step="0.01"
            :disabled="
              movimentoManterValor &&
              campoObrigatorioChave(regra) === 'valor_negociacao'
            "
          />
          <b-form-input
            v-else
            v-model="movimentoCamposForm[regra.id_crm_campo_comercial]"
          />
          <small v-if="regra.mensagem" class="text-muted">
            {{ regra.mensagem }}
          </small>
        </b-form-group>
      </div>
    </b-modal>

    <b-modal
      id="crm-funil-temperatura-modal"
      title="Temperatura da oportunidade"
      @ok.prevent="salvarTemperaturaOportunidade"
    >
      <b-form-group label="Oportunidade">
        <b-form-input :value="oportunidadeSelecionada.titulo" disabled />
      </b-form-group>
      <div class="crm-temperature-grid">
        <button
          v-for="option in temperaturaOptions"
          :key="String(option.value)"
          class="crm-temperature-option"
          :class="{ active: temperaturaForm.temperatura === option.value }"
          :style="{ '--temperature-color': temperaturaColor(option.value) }"
          type="button"
          @click="temperaturaForm.temperatura = option.value"
        >
          <i :class="temperaturaIcon(option.value)"></i>
          <span>{{ option.text }}</span>
        </button>
      </div>
    </b-modal>

    <b-modal
      id="crm-funil-acoes-modal"
      title="Ações da oportunidade"
      hide-footer
    >
      <div class="crm-actions-modal">
        <button
          class="btn btn-light btn-block"
          type="button"
          @click="abrirDetalhe(oportunidadeSelecionada)"
        >
          Abrir detalhe
        </button>
        <button
          class="btn btn-light btn-block"
          type="button"
          @click="abrirModalEdicao(oportunidadeSelecionada)"
        >
          Editar oportunidade
        </button>
        <button
          class="btn btn-light-primary btn-block"
          type="button"
          @click="abrirModalMover(oportunidadeSelecionada)"
        >
          Mover etapa
        </button>
        <button
          v-if="isContrato(oportunidadeSelecionada)"
          class="btn btn-light-info btn-block"
          type="button"
          @click="abrirDadosNegociacao(oportunidadeSelecionada)"
        >
          Visualizar dados da negociação
        </button>
        <button
          v-if="isContrato(oportunidadeSelecionada)"
          class="btn btn-light-success btn-block"
          type="button"
          :disabled="!telefoneContrato(oportunidadeSelecionada)"
          @click="enviarContratoWhatsapp(oportunidadeSelecionada)"
        >
          Enviar contrato por WhatsApp
        </button>
        <button
          v-if="isContrato(oportunidadeSelecionada)"
          class="btn btn-light-primary btn-block"
          type="button"
          :disabled="!emailContrato(oportunidadeSelecionada)"
          @click="enviarContratoEmail(oportunidadeSelecionada)"
        >
          Enviar contrato por e-mail
        </button>
        <button
          class="btn btn-light-success btn-block"
          type="button"
          @click="abrirModalGanho(oportunidadeSelecionada)"
        >
          Marcar como ganha
        </button>
        <button
          class="btn btn-light-danger btn-block"
          type="button"
          @click="abrirModalPerda(oportunidadeSelecionada)"
        >
          Marcar como perdida
        </button>
      </div>
    </b-modal>

    <b-modal
      id="crm-perder-oportunidade-modal"
      title="Marcar como perdida"
      @ok.prevent="marcarPerdida"
    >
      <b-form-group label="Motivo da perda">
        <b-form-select
          v-model="perda.id_crm_motivo_perda"
          :options="motivoPerdaOptions"
        />
      </b-form-group>
      <b-form-group label="Observação">
        <b-form-textarea v-model="perda.motivo_perda_observacao" rows="3" />
      </b-form-group>
    </b-modal>

    <b-modal
      id="crm-ganhar-oportunidade-modal"
      title="Fechar oportunidade"
      cancel-title="Cancelar"
      ok-title="Confirmar"
      size="xl"
      @ok.prevent="marcarGanha"
    >
      <div class="crm-close-summary">
        <strong>{{ ganho.titulo }}</strong>
        <span>{{ ganho.cliente }}</span>
      </div>
      <b-row>
        <b-col md="6">
          <b-form-group label="Nome correto">
            <b-form-input v-model="ganho.nome_correto" maxlength="120" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="CNPJ">
            <b-input-group>
              <b-form-input v-model="ganho.cnpj" maxlength="18" />
              <b-input-group-append>
                <button
                  class="btn btn-light-primary"
                  type="button"
                  :disabled="loadingConsultaCnpjFechamento"
                  @click="consultarCnpjFechamento"
                >
                  <i class="la la-search"></i>
                  Consultar
                </button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group label="E-mail">
            <b-form-input
              v-model="ganho.email_cliente"
              type="email"
              maxlength="120"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Telefone">
            <b-form-input v-model="ganho.telefone_cliente" maxlength="20" />
          </b-form-group>
        </b-col>
      </b-row>
      <div class="crm-close-address">
        <b-row>
          <b-col md="5">
            <b-form-group label="CEP">
              <b-input-group>
                <b-form-input v-model="ganho.cep" maxlength="9" />
                <b-input-group-append>
                  <button
                    class="btn btn-light-primary"
                    type="button"
                    :disabled="loadingConsultaCepFechamento"
                    @click="consultarCepFechamento"
                  >
                    <i class="la la-search"></i>
                    Consultar
                  </button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="7">
            <b-form-group label="Cidade">
              <b-form-input :value="cidadeFechamentoLabel" disabled />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-form-group label="Logradouro">
              <b-form-input v-model="ganho.logradouro" maxlength="100" />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Número">
              <b-form-input v-model="ganho.numero" maxlength="30" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="Bairro">
              <b-form-input v-model="ganho.bairro" maxlength="100" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Complemento">
              <b-form-input v-model="ganho.complemento" maxlength="100" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group label="Endereço completo">
          <b-form-input v-model="ganho.endereco_cliente" maxlength="255" />
        </b-form-group>
      </div>
      <b-form-group label="Valor final">
        <money
          class="form-control"
          v-model="ganho.valor_final"
          v-bind="priceOptions"
        />
      </b-form-group>
      <b-form-group label="Benefícios digitáveis">
        <b-form-textarea
          v-model="ganho.beneficios_livres"
          rows="3"
          max-rows="5"
          placeholder="Digite descontos, parcelamentos, bônus ou observações combinadas."
        />
      </b-form-group>
      <b-form-group v-if="!ganho.cliente_final" label="Benefícios de regra">
        <div class="crm-benefit-suggestions">
          <button
            v-for="beneficio in beneficioOptions"
            :key="beneficio.value"
            :class="[
              'crm-benefit-chip',
              { active: beneficioEstruturadoSelecionado(beneficio.value) },
            ]"
            type="button"
            @click="toggleBeneficioGanho(beneficio.value)"
          >
            {{ beneficio.text }}
          </button>
        </div>
      </b-form-group>
      <small class="text-muted">
        Ao confirmar, o CRM salva os dados do cliente, registra os benefícios na
        oportunidade e cria a entrada no funil Contratos.
      </small>
    </b-modal>

    <b-modal
      id="crm-dados-negociacao-modal"
      title="Dados da negociação"
      hide-footer
    >
      <div class="crm-negotiation-data">
        <div>
          <span>Cliente</span>
          <strong>{{ dadosNegociacao.cliente }}</strong>
        </div>
        <div>
          <span>Negociação original</span>
          <strong>{{ dadosNegociacao.origem }}</strong>
        </div>
        <div>
          <span>Valor</span>
          <strong>{{ formatMoney(dadosNegociacao.valor) }}</strong>
        </div>
        <div>
          <span>Telefone</span>
          <strong>{{ dadosNegociacao.telefone || "Não informado" }}</strong>
        </div>
        <div>
          <span>E-mail</span>
          <strong>{{ dadosNegociacao.email || "Não informado" }}</strong>
        </div>
        <div>
          <span>Benefícios concedidos</span>
          <strong>{{ dadosNegociacao.beneficios || "Não informado" }}</strong>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-4">
        <button
          class="btn btn-light"
          type="button"
          @click="$bvModal.hide('crm-dados-negociacao-modal')"
        >
          Fechar
        </button>
      </div>
    </b-modal>

    <b-sidebar
      id="crm-funil-tarefa-drawer"
      v-model="tarefaDrawerVisible"
      title="Criar tarefa"
      backdrop
      right
      shadow
      width="520px"
    >
      <div class="crm-drawer-body">
        <b-form-group label="Oportunidade">
          <b-form-input :value="oportunidadeSelecionada.titulo" disabled />
        </b-form-group>
        <b-form-group label="Título">
          <b-form-input v-model="tarefaForm.titulo" maxlength="140" />
        </b-form-group>
        <b-row>
          <b-col md="6">
            <b-form-group label="Tipo">
              <b-form-select
                v-model="tarefaForm.tipo"
                :options="tipoTarefaOptions"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Responsável">
              <b-form-select
                v-model="tarefaForm.id_usuario"
                :options="usuarioOptionsSemTodos"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group label="Vencimento">
          <b-form-input
            v-model="tarefaForm.vencimento_em"
            type="datetime-local"
          />
        </b-form-group>
        <b-form-group label="Descrição">
          <b-form-textarea v-model="tarefaForm.descricao" rows="3" />
        </b-form-group>
        <b-form-checkbox v-model="tarefaForm.concluir_ao_criar" switch>
          Concluir ao criar
        </b-form-checkbox>
      </div>
      <template #footer>
        <div class="crm-drawer-footer">
          <button
            class="btn btn-light"
            type="button"
            @click="tarefaDrawerVisible = false"
          >
            Cancelar
          </button>
          <button
            class="btn btn-light-primary"
            type="button"
            @click="criarTarefa(true)"
          >
            Salvar e agendar
          </button>
          <button
            class="btn btn-dark"
            type="button"
            @click="criarTarefa(false)"
          >
            Salvar tarefa
          </button>
        </div>
      </template>
    </b-sidebar>

    <b-sidebar
      id="crm-funil-agenda-drawer"
      v-model="agendaDrawerVisible"
      :title="agendaDrawerTitle"
      backdrop
      right
      shadow
      width="560px"
    >
      <div class="crm-drawer-body">
        <b-form-group label="Oportunidade">
          <b-form-input :value="oportunidadeSelecionada.titulo" disabled />
        </b-form-group>
        <div v-if="tarefaAgendamentoOrigem" class="crm-agenda-cliente mb-4">
          <span>Tarefa vinculada</span>
          <strong>{{ tarefaAgendamentoOrigem.titulo }}</strong>
        </div>
        <div class="crm-agenda-cliente mb-4">
          <span>Cliente ou contato</span>
          <strong>{{ agendaClienteLabel }}</strong>
        </div>
        <b-form-group label="Título">
          <b-form-input v-model="agendaForm.titulo" maxlength="140" />
        </b-form-group>
        <b-row>
          <b-col md="6">
            <b-form-group label="Tipo">
              <b-form-select
                v-model="agendaForm.tipo"
                :options="tipoAgendaOptions"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label="agendaResponsavelLabel">
              <b-form-select
                v-model="agendaForm.id_usuario"
                :options="agendaResponsavelOptions"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="Data e horário">
              <b-form-input
                v-model="agendaForm.data_inicio"
                type="datetime-local"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Duração em minutos">
              <b-form-input
                v-model="agendaForm.duracao_minutos"
                type="number"
                min="1"
                max="1440"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <div class="crm-agenda-horarios">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <div>
              <strong>Horários disponíveis</strong>
              <small class="crm-agenda-context">
                {{ agendaHorariosContextoLabel }}
              </small>
            </div>
            <button
              class="btn btn-light-primary btn-sm"
              type="button"
              :disabled="loadingAgendaHorarios"
              @click="buscarHorariosAgenda"
            >
              Buscar horários
            </button>
          </div>
          <div v-if="agendaHorariosErro" class="alert alert-light-danger">
            {{ agendaHorariosErro }}
          </div>
          <div v-else-if="loadingAgendaHorarios" class="text-muted">
            Carregando horários...
          </div>
          <div v-else-if="agendaSlots.length === 0" class="text-muted">
            Busque os horários antes de marcar.
          </div>
          <div v-else class="crm-agenda-slots">
            <button
              v-for="slot in agendaSlots"
              :key="slot.inicio"
              class="crm-agenda-slot"
              :class="{
                selected: agendaSlotSelecionado(slot),
                unavailable: !slot.disponivel,
              }"
              type="button"
              :aria-pressed="agendaSlotSelecionado(slot)"
              :disabled="!slot.disponivel"
              @click="selecionarHorarioAgenda(slot)"
            >
              <strong>{{ formatTime(slot.inicio) }}</strong>
              <small>
                {{ slot.disponivel ? "Livre" : slot.motivo || "Ocupado" }}
              </small>
            </button>
          </div>
        </div>
        <b-form-group label="Descrição">
          <b-form-textarea v-model="agendaForm.descricao" rows="3" />
        </b-form-group>
      </div>
      <template #footer>
        <div class="crm-drawer-footer">
          <button
            class="btn btn-light"
            type="button"
            @click="agendaDrawerVisible = false"
          >
            Cancelar
          </button>
          <button class="btn btn-dark" type="button" @click="criarAgenda">
            Salvar agendamento
          </button>
        </div>
      </template>
    </b-sidebar>

    <b-modal
      id="crm-funil-nota-modal"
      title="Adicionar nota"
      @ok.prevent="adicionarNota"
    >
      <b-form-group label="Oportunidade">
        <b-form-input :value="oportunidadeSelecionada.titulo" disabled />
      </b-form-group>
      <b-form-group label="Nota">
        <b-form-textarea v-model="notaForm.descricao" rows="4" />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import BuscaClienteContato from "@/modules/CRM/components/BuscaClienteContato";
import CrmActiveFilters from "@/modules/CRM/components/CrmActiveFilters";
import CrmDealCard from "@/modules/CRM/components/CrmDealCard";
import CrmEmptyState from "@/modules/CRM/components/CrmEmptyState";
import CrmToolbar from "@/modules/CRM/components/CrmToolbar";
import crmService from "@/modules/CRM/services/crmService";
import { SistemaMixin, priceOptions } from "@/modules/Application";
import { Money } from "v-money";

const KANBAN_LIMIT = 30;
const LAST_FUNNEL_STORAGE_KEY = "crm.funil.ultimo_id";

export default {
  name: "crm-funil",
  components: {
    BuscaClienteContato,
    CrmActiveFilters,
    CrmDealCard,
    CrmEmptyState,
    CrmToolbar,
    Money,
  },
  mixins: [SistemaMixin],
  data() {
    return {
      buscaTimer: null,
      priceOptions,
      funis: [],
      fontes: [],
      agendaDrawerVisible: false,
      filtersDrawerVisible: false,
      kanban: null,
      kanbanError: "",
      kanbanScrollWidth: 0,
      kanbanScrollSyncing: false,
      loading: false,
      loadingAgendaHorarios: false,
      loadingConsultaCepFechamento: false,
      loadingConsultaCnpjFechamento: false,
      loadingEtapas: {},
      savingOportunidade: false,
      agendaHorarios: null,
      agendaHorariosErro: "",
      motivosPerda: [],
      temperaturaOptions: [
        { value: null, text: "Sem temperatura" },
        { value: "muito_frio", text: "Muito frio" },
        { value: "frio", text: "Frio" },
        { value: "morno", text: "Morno" },
        { value: "quente", text: "Quente" },
        { value: "venda_certa", text: "Venda certa" },
      ],
      tiposTarefa: [],
      usuarios: [],
      vendedoresAtribuicao: [],
      desenvolvedoresAtribuicao: [],
      treinamentoAtribuicao: [],
      filtros: this.filtrosPadrao(),
      dragState: this.emptyDragState(),
      agendaForm: this.emptyAgendaForm(),
      form: this.emptyForm(),
      notaForm: this.emptyNotaForm(),
      vinculoSelecionado: null,
      oportunidadeSelecionada: {},
      temperaturaForm: {
        temperatura: null,
      },
      dadosNegociacao: this.emptyDadosNegociacao(),
      idEtapaDestino: null,
      idUsuarioTecnicoDestino: null,
      idUsuarioDestino: null,
      concederAcessoFunilDestino: false,
      movimentoCamposForm: {},
      movimentoManterValor: true,
      perda: this.emptyPerda(),
      ganho: this.emptyGanho(),
      tarefaForm: this.emptyTarefaForm(),
      tarefaAgendamentoOrigem: null,
      tarefaDrawerVisible: false,
      wizardStep: 0,
      wizardSteps: [
        { key: "titulo", label: "Nome" },
        { key: "contato", label: "Contato" },
        { key: "comercial", label: "Dados" },
        { key: "confirmacao", label: "Confirmar" },
      ],
      tipoAgendaOptions: [
        { value: "follow_up", text: "Follow-up" },
        { value: "reuniao", text: "Reunião" },
        { value: "visita", text: "Visita" },
        { value: "demonstracao", text: "Demonstração" },
        { value: "treinamento", text: "Treinamento" },
        {
          value: "treinamento_cliente_final",
          text: "Treinamento Cliente Final",
        },
        { value: "outro", text: "Outro" },
      ],
      periodoAtividadeOptions: [
        { value: "Todos", text: "Todas" },
        { value: "hoje", text: "Hoje" },
        { value: "atrasadas", text: "Atrasadas" },
        { value: "proximas", text: "Próximos 7 dias" },
        { value: "sem_atividade", text: "Sem próxima tarefa" },
      ],
      statusOptions: [
        { value: "aberta", text: "Abertas" },
        { value: "Todos", text: "Todos" },
        { value: "ganha", text: "Ganhas" },
        { value: "perdida", text: "Perdidas" },
      ],
      beneficioOptions: [
        { value: "website", text: "Website" },
        {
          value: "implementacao_white_label",
          text: "Implementação White Label",
        },
        {
          value: "treinamento_cliente_final",
          text: "Treinamento Cliente Final",
        },
      ],
    };
  },
  computed: {
    modalTitle() {
      return this.form.id_crm_oportunidade
        ? "Editar oportunidade"
        : "Nova oportunidade";
    },
    funilOptions() {
      return [{ value: null, text: "Funil padrão" }].concat(
        this.funilOptionsSemTodos
      );
    },
    funisNavegacao() {
      return this.funis
        .map((funil) => ({
          value: funil.id_crm_funil,
          text: funil.nome,
          ordem: Number(funil.ordem || 0),
        }))
        .sort((a, b) => a.ordem - b.ordem || a.text.localeCompare(b.text));
    },
    funilOptionsSemTodos() {
      return this.funisNavegacao.map((funil) => ({
        value: funil.value,
        text: funil.text,
      }));
    },
    funilAtualId() {
      if (this.filtros.id_crm_funil) {
        return this.filtros.id_crm_funil;
      }

      return this.kanban && this.kanban.funil
        ? this.kanban.funil.id_crm_funil
        : null;
    },
    funilAtual() {
      return (
        this.funis.find(
          (item) => Number(item.id_crm_funil) === Number(this.funilAtualId)
        ) || (this.kanban ? this.kanban.funil : null)
      );
    },
    funilAtualClienteFinal() {
      return (
        this.funilAtual &&
        this.funilAtual.chave_preset === "vendas_cliente_final"
      );
    },
    usuarioOptions() {
      return [{ value: null, text: "Todos" }].concat(
        this.usuarioOptionsSemTodos
      );
    },
    usuarioOptionsSemTodos() {
      return this.usuarios.map((usuario) => ({
        value: usuario.id_usuario,
        text: usuario.nome || usuario.usuario,
      }));
    },
    vendedorResponsavelOptions() {
      const vendedores = this.vendedoresAtribuicao.length
        ? this.vendedoresAtribuicao
        : this.usuarios;

      return vendedores.map((usuario) => ({
        value: usuario.id_usuario,
        text: usuario.nome || usuario.usuario,
      }));
    },
    desenvolvedorResponsavelOptions() {
      const desenvolvedores = this.desenvolvedoresAtribuicao.length
        ? this.desenvolvedoresAtribuicao
        : this.usuarios;

      return desenvolvedores.map((usuario) => ({
        value: usuario.id_usuario,
        text: usuario.nome || usuario.usuario,
      }));
    },
    treinamentoResponsavelOptions() {
      const usuarios = this.treinamentoAtribuicao.length
        ? this.treinamentoAtribuicao
        : this.usuarios;

      return usuarios.map((usuario) => ({
        value: usuario.id_usuario,
        text: usuario.nome || usuario.usuario,
      }));
    },
    agendaResponsavelOptions() {
      return this.isTreinamentoClienteFinal(this.oportunidadeSelecionada)
        ? this.treinamentoResponsavelOptions
        : this.usuarioOptionsSemTodos;
    },
    agendaDrawerTitle() {
      return this.isTreinamentoClienteFinal(this.oportunidadeSelecionada)
        ? "Agendar treinamento"
        : "Criar agendamento CRM";
    },
    agendaResponsavelLabel() {
      return this.isTreinamentoClienteFinal(this.oportunidadeSelecionada)
        ? "Responsável pelo treinamento"
        : "Responsável";
    },
    agendaHorariosContextoLabel() {
      const responsavel =
        this.optionText(
          this.agendaResponsavelOptions,
          this.agendaForm.id_usuario
        ) || "responsável não selecionado";
      const data = this.dateFromDateTimeLocal(this.agendaForm.data_inicio);
      const dataLabel = data
        ? new Date(`${data}T00:00:00`).toLocaleDateString("pt-BR")
        : "data não informada";

      return `${responsavel} em ${dataLabel}`;
    },
    fonteOptions() {
      return [{ value: null, text: "Sem fonte" }].concat(
        this.fontes.map((fonte) => ({
          value: fonte.id_crm_fonte,
          text: fonte.nome,
        }))
      );
    },
    fonteFiltroOptions() {
      return [{ value: null, text: "Todas" }].concat(
        this.fontes.map((fonte) => ({
          value: fonte.id_crm_fonte,
          text: fonte.nome,
        }))
      );
    },
    temperaturaFiltroOptions() {
      return [
        { value: "Todos", text: "Todas" },
        { value: "__sem_temperatura__", text: "Sem temperatura" },
      ].concat(
        this.temperaturaOptions.filter((option) => option.value !== null)
      );
    },
    motivoPerdaOptions() {
      return [{ value: null, text: "Selecione" }].concat(
        this.motivosPerda.map((motivo) => ({
          value: motivo.id_crm_motivo_perda,
          text: motivo.nome,
        }))
      );
    },
    agendaSlots() {
      return this.agendaHorarios ? this.agendaHorarios.slots || [] : [];
    },
    tipoTarefaOptions() {
      const ativos = this.tiposTarefa.filter((tipo) => tipo.ativo !== false);
      const tipos = ativos.length
        ? ativos
        : [
            { nome: "Tarefa", chave: "tarefa" },
            { nome: "Ligação", chave: "ligacao" },
            { nome: "Reunião", chave: "reuniao" },
            { nome: "Nota", chave: "nota" },
            { nome: "Follow-up", chave: "follow_up" },
          ];

      return tipos.map((tipo) => ({
        value: tipo.chave,
        text: tipo.nome,
      }));
    },
    agendaClienteLabel() {
      return (
        this.oportunidadeSelecionada.pessoa ||
        this.oportunidadeSelecionada.contato ||
        "Sem cliente/contato informado"
      );
    },
    cidadeFechamentoLabel() {
      return [this.ganho.cidade, this.ganho.uf].filter(Boolean).join(" / ");
    },
    activeFilters() {
      return [
        {
          key: "id_usuario",
          label: "Responsável",
          value: this.optionText(
            this.usuarioOptionsSemTodos,
            this.filtros.id_usuario
          ),
        },
        {
          key: "status",
          label: "Status",
          value:
            this.filtros.status && this.filtros.status !== "aberta"
              ? this.optionText(this.statusOptions, this.filtros.status)
              : null,
        },
        {
          key: "id_crm_fonte",
          label: "Fonte",
          value: this.filtros.id_crm_fonte
            ? this.optionText(this.fonteOptions, this.filtros.id_crm_fonte)
            : null,
        },
        {
          key: "periodo_atividade",
          label: "Próxima tarefa",
          value:
            this.filtros.periodo_atividade &&
            this.filtros.periodo_atividade !== "Todos"
              ? this.optionText(
                  this.periodoAtividadeOptions,
                  this.filtros.periodo_atividade
                )
              : null,
        },
        {
          key: "temperatura",
          label: "Temperatura",
          value:
            this.filtros.temperatura && this.filtros.temperatura !== "Todos"
              ? this.optionText(
                  this.temperaturaFiltroOptions,
                  this.filtros.temperatura
                )
              : null,
        },
        { key: "busca", label: "Busca", value: this.filtros.busca },
        {
          key: "busca_notas",
          label: "Notas",
          value: this.filtros.busca_notas,
        },
        {
          key: "data_inicio",
          label: "Data inicial",
          value: this.filtros.data_inicio,
        },
        { key: "data_fim", label: "Data final", value: this.filtros.data_fim },
      ];
    },
    activeFilterCount() {
      return this.activeFilters.filter((filter) => !!filter.value).length;
    },
    etapaDestinoSelecionada() {
      return this.findEtapaById(this.idEtapaDestino);
    },
    camposObrigatoriosMovimento() {
      return this.camposObrigatoriosEtapa(this.etapaDestinoSelecionada);
    },
    movimentoExigeValorNegociacao() {
      return this.camposObrigatoriosMovimento.some(
        (regra) => this.campoObrigatorioChave(regra) === "valor_negociacao"
      );
    },
    movimentoExigeAtribuicao() {
      const origem = this.findEtapaById(
        this.oportunidadeSelecionada.id_crm_etapa
      );
      const destino = this.findEtapaById(this.idEtapaDestino);

      return (
        !this.oportunidadeTemVendedorResponsavel(
          this.oportunidadeSelecionada
        ) &&
        this.etapaPossuiChave(origem, "primeiro_contato") &&
        this.etapaPossuiChave(destino, "qualificacao")
      );
    },
    usuarioDestinoSemAcesso() {
      if (!this.movimentoExigeAtribuicao || !this.idUsuarioDestino) {
        return false;
      }

      if (this.usuarioTemAcessoPorPapelAoFunilAtual(this.idUsuarioDestino)) {
        return false;
      }

      const ids = this.funilAtualUsuariosAcesso;
      return ids.length > 0 && !ids.includes(Number(this.idUsuarioDestino));
    },
    funilAtualUsuariosAcesso() {
      const funil =
        this.funis.find(
          (item) => Number(item.id_crm_funil) === Number(this.funilAtualId)
        ) || (this.kanban ? this.kanban.funil : null);
      const acessos =
        funil && funil.usuarios_acesso ? funil.usuarios_acesso : [];

      return acessos
        .filter((acesso) => acesso.ativo !== false)
        .map((acesso) => Number(acesso.id_usuario));
    },
    movimentoExigeTecnico() {
      return (
        !this.oportunidadeTemResponsavelTecnico(this.oportunidadeSelecionada) &&
        this.isEtapaApresentacaoTecnica(this.etapaDestinoSelecionada)
      );
    },
    vinculoSelecionadoLabel() {
      return this.vinculoSelecionado
        ? this.vinculoSelecionado.label
        : "Nenhum contato selecionado";
    },
    wizardFunilEtapaLabel() {
      const funil = this.optionText(
        this.funilOptionsSemTodos,
        this.form.id_crm_funil
      );
      const etapa = this.etapaInicialLabel(this.form.id_crm_funil);

      return [funil, etapa].filter(Boolean).join(" · ");
    },
    wizardPreviewOportunidade() {
      return {
        id_crm_oportunidade: "preview",
        titulo: this.form.titulo || "Nova oportunidade",
        contato: this.vinculoSelecionadoLabel,
        pessoa: null,
        fonte: this.optionText(this.fonteOptions, this.form.id_crm_fonte),
        campanha: this.form.campanha,
        usuario: this.optionText(
          this.usuarioOptionsSemTodos,
          this.form.id_usuario
        ),
        valor_estimado: this.form.valor_estimado || 0,
        status: "aberta",
        temperatura: this.form.temperatura,
        proxima_atividade_em: this.form.proxima_atividade_em,
      };
    },
    wizardOrigemLabel() {
      const fonte = this.optionText(this.fonteOptions, this.form.id_crm_fonte);
      const campanha = this.form.campanha;

      return (
        [fonte && fonte !== "Sem fonte" ? fonte : null, campanha]
          .filter(Boolean)
          .join(" · ") || "Não informada"
      );
    },
  },
  mounted() {
    this.loadBase();
    window.addEventListener("resize", this.atualizarKanbanScrollWidth);
  },
  beforeDestroy() {
    clearTimeout(this.buscaTimer);
    window.removeEventListener("resize", this.atualizarKanbanScrollWidth);
  },
  watch: {
    "agendaForm.id_usuario": "resetAgendaHorarios",
    "agendaForm.data_inicio": "resetAgendaHorarios",
    "agendaForm.duracao_minutos": "resetAgendaHorarios",
  },
  methods: {
    filtrosPadrao() {
      return {
        id_crm_funil: null,
        id_usuario: null,
        id_crm_fonte: null,
        status: "aberta",
        busca: "",
        busca_notas: "",
        temperatura: "Todos",
        periodo_atividade: "Todos",
        data_inicio: null,
        data_fim: null,
      };
    },
    emptyForm() {
      return {
        id_crm_oportunidade: null,
        titulo: "",
        id_crm_funil: null,
        id_crm_etapa: null,
        id_usuario: null,
        id_crm_fonte: null,
        campanha: "",
        valor_estimado: 0,
        previsao_fechamento: null,
        proxima_atividade_em: null,
        temperatura: null,
      };
    },
    emptyTarefaForm() {
      return {
        titulo: "",
        tipo: "tarefa",
        id_usuario: null,
        vencimento_em: this.toDateTimeLocal(new Date()),
        descricao: "",
        concluir_ao_criar: false,
      };
    },
    emptyAgendaForm() {
      return {
        id_crm_atividade: null,
        titulo: "",
        tipo: "follow_up",
        id_usuario: null,
        data_inicio: this.toDateTimeLocal(new Date()),
        duracao_minutos: 30,
        descricao: "",
      };
    },
    emptyNotaForm() {
      return {
        descricao: "",
      };
    },
    emptyPerda() {
      return {
        id_crm_oportunidade: null,
        id_crm_motivo_perda: null,
        motivo_perda_observacao: "",
      };
    },
    emptyGanho() {
      return {
        id_crm_oportunidade: null,
        titulo: "",
        cliente: "",
        nome_correto: "",
        cnpj: "",
        email_cliente: "",
        telefone_cliente: "",
        endereco_cliente: "",
        cep: "",
        logradouro: "",
        numero: "",
        bairro: "",
        complemento: "",
        id_cidade: null,
        cidade: "",
        uf: "",
        valor_final: 0,
        beneficios: "",
        beneficios_livres: "",
        beneficios_estruturados: [],
        cliente_final: false,
      };
    },
    emptyDadosNegociacao() {
      return {
        cliente: "",
        origem: "",
        valor: 0,
        telefone: "",
        email: "",
        beneficios: "",
      };
    },
    emptyDragState() {
      return {
        oportunidade: null,
        origemId: null,
        destinoId: null,
        moving: false,
      };
    },
    async loadBase() {
      const [
        funis,
        motivos,
        usuarios,
        tiposTarefa,
        temperaturas,
        fontes,
        vendedoresAtribuicao,
        desenvolvedoresAtribuicao,
        treinamentoAtribuicao,
      ] = await Promise.all([
        crmService.funis(),
        crmService.motivosPerda(),
        crmService.usuarios({
          per_page: 100,
          page: 1,
          sort: [{ field: "nome", type: "asc" }],
        }),
        crmService.tiposTarefaConfiguracao(),
        crmService.temperaturasConfiguracao(),
        crmService.fontes(),
        crmService.usuariosAtribuicoesConfiguracao({ papel: "vendedor" }),
        crmService.usuariosAtribuicoesConfiguracao({ papel: "desenvolvedor" }),
        crmService.usuariosAtribuicoesConfiguracao({ papel: "treinamento" }),
      ]);
      this.funis = this.normalizeCollection(funis.data);
      this.motivosPerda = this.normalizeCollection(motivos.data);
      this.usuarios = this.normalizeCollection(usuarios.data);
      this.tiposTarefa = this.normalizeCollection(tiposTarefa.data);
      this.temperaturaOptions = this.temperaturaOptionsFromList(
        this.normalizeCollection(temperaturas.data)
      );
      this.fontes = this.normalizeCollection(fontes.data);
      this.vendedoresAtribuicao =
        this.vendedoresFromAtribuicoes(vendedoresAtribuicao);
      this.desenvolvedoresAtribuicao = this.desenvolvedoresFromAtribuicoes(
        desenvolvedoresAtribuicao
      );
      this.treinamentoAtribuicao = this.usuariosPorPapelFromAtribuicoes(
        treinamentoAtribuicao,
        "treinamento"
      );
      this.restaurarUltimoFunilSelecionado();
      this.loadKanban();
    },
    normalizeCollection(data) {
      if (Array.isArray(data)) {
        return data;
      }

      if (data && Array.isArray(data.data)) {
        return data.data;
      }

      return [];
    },
    temperaturaOptionsFromList(temperaturas) {
      const ativos = temperaturas.filter((item) => item.ativo !== false);

      if (!ativos.length) {
        return this.temperaturaOptions;
      }

      return [{ value: null, text: "Sem temperatura" }].concat(
        ativos.map((item) => ({
          value: item.chave,
          text: item.nome,
          cor: item.cor,
        }))
      );
    },
    etapaAutomacaoResumo(etapa) {
      const partes = [];

      if (etapa.sugerir_tarefa) {
        partes.push("sugere tarefa");
      }

      if (etapa.destacar_sem_tarefa) {
        partes.push("sem tarefa");
      }

      if (etapa.alertar_oportunidade_parada) {
        partes.push(`${etapa.alerta_parada_dias || 7}d parada`);
      }

      return partes.join(" · ");
    },
    buildKanbanParams(extra = {}) {
      return {
        ...this.filtros,
        modo: "leve",
        limit: KANBAN_LIMIT,
        ...extra,
      };
    },
    async loadKanban() {
      this.loading = true;
      this.kanbanError = "";
      try {
        const params = this.buildKanbanParams();
        const { data } = await crmService.kanban(params);
        this.kanban = data;
        const idFunilCarregado =
          data && data.funil
            ? data.funil.id_crm_funil
            : this.filtros.id_crm_funil;
        this.gravarUltimoFunilSelecionado(idFunilCarregado);
        this.$nextTick(this.atualizarKanbanScrollWidth);
      } catch (error) {
        this.kanban = null;
        this.kanbanError = this.apiError(
          error,
          "Você não tem permissão para acessar este funil CRM."
        );
        this.$toast.error(this.kanbanError);
      } finally {
        this.loading = false;
      }
    },
    debouncedLoadKanban() {
      clearTimeout(this.buscaTimer);
      this.buscaTimer = setTimeout(() => this.loadKanban(), 450);
    },
    limparBuscaRapida() {
      this.filtros.busca = "";
      this.debouncedLoadKanban();
    },
    limparFiltros() {
      const idFunilAtual = this.funilAtualId;
      this.filtros = {
        ...this.filtrosPadrao(),
        id_crm_funil: idFunilAtual,
      };
      this.filtersDrawerVisible = false;
      this.gravarUltimoFunilSelecionado(idFunilAtual);
      this.loadKanban();
    },
    aplicarFiltros() {
      this.filtersDrawerVisible = false;
      this.gravarUltimoFunilSelecionado(this.filtros.id_crm_funil);
      this.loadKanban();
    },
    limparFiltroAtivo(key) {
      if (key === "status") {
        this.filtros.status = "aberta";
      } else if (key === "periodo_atividade") {
        this.filtros.periodo_atividade = "Todos";
      } else if (key === "temperatura") {
        this.filtros.temperatura = "Todos";
      } else if (key === "busca") {
        this.filtros.busca = "";
      } else if (key === "busca_notas") {
        this.filtros.busca_notas = "";
      } else {
        this.filtros[key] = null;
      }

      this.loadKanban();
    },
    selecionarFunilRapido(idFunil) {
      if (Number(this.funilAtualId) === Number(idFunil)) {
        return;
      }

      this.filtros.id_crm_funil = idFunil;
      this.gravarUltimoFunilSelecionado(idFunil);
      this.loadKanban();
    },
    restaurarUltimoFunilSelecionado() {
      const idFunil = this.lerUltimoFunilSelecionado();

      if (!idFunil) {
        return;
      }

      const existe = this.funis.some(
        (funil) => Number(funil.id_crm_funil) === Number(idFunil)
      );

      if (existe) {
        this.filtros.id_crm_funil = Number(idFunil);
      }
    },
    lerUltimoFunilSelecionado() {
      try {
        return window.localStorage.getItem(LAST_FUNNEL_STORAGE_KEY);
      } catch (error) {
        return null;
      }
    },
    gravarUltimoFunilSelecionado(idFunil) {
      if (!idFunil) {
        return;
      }

      try {
        window.localStorage.setItem(LAST_FUNNEL_STORAGE_KEY, String(idFunil));
      } catch (error) {
        // Sem armazenamento local disponível, o funil segue funcionando normalmente.
      }
    },
    atualizarKanbanScrollWidth() {
      const kanban = this.$refs.kanbanScroll;

      if (!kanban) {
        this.kanbanScrollWidth = 0;
        return;
      }

      this.kanbanScrollWidth = kanban.scrollWidth;
    },
    sincronizarKanbanScroll(origem) {
      if (this.kanbanScrollSyncing) {
        return;
      }

      const topScroll = this.$refs.kanbanTopScroll;
      const bottomScroll = this.$refs.kanbanScroll;

      if (!topScroll || !bottomScroll) {
        return;
      }

      const origemScroll = origem === "top" ? topScroll : bottomScroll;
      const destinoScroll = origem === "top" ? bottomScroll : topScroll;

      this.kanbanScrollSyncing = true;
      destinoScroll.scrollLeft = origemScroll.scrollLeft;
      window.requestAnimationFrame(() => {
        this.kanbanScrollSyncing = false;
      });
    },
    optionText(options, value) {
      const option = options.find((item) => item.value === value);
      return option ? option.text : null;
    },
    etapaOptions(idFunil) {
      const funil =
        this.funis.find(
          (item) => Number(item.id_crm_funil) === Number(idFunil)
        ) || (this.kanban ? this.kanban.funil : null);
      const etapas = funil && funil.etapas ? funil.etapas : [];
      return [{ value: null, text: "Primeira etapa" }].concat(
        etapas.map((etapa) => ({
          value: etapa.id_crm_etapa,
          text: etapa.nome,
        }))
      );
    },
    etapaInicialLabel(idFunil) {
      const kanbanFunil = this.kanban ? this.kanban.funil : null;
      const funil =
        this.funis.find(
          (item) => Number(item.id_crm_funil) === Number(idFunil)
        ) ||
        (kanbanFunil && Number(kanbanFunil.id_crm_funil) === Number(idFunil)
          ? kanbanFunil
          : null);
      const etapas = funil && Array.isArray(funil.etapas) ? funil.etapas : [];
      const [primeira] = etapas
        .filter((etapa) => etapa.ativo !== false)
        .sort(
          (a, b) =>
            Number(a.ordem || 0) - Number(b.ordem || 0) ||
            String(a.nome || "").localeCompare(String(b.nome || ""))
        );

      return primeira ? primeira.nome : "Primeira etapa ativa";
    },
    findEtapaById(idEtapa) {
      if (!idEtapa) {
        return null;
      }

      if (this.kanban && Array.isArray(this.kanban.colunas)) {
        const coluna = this.kanban.colunas.find(
          (item) => item.etapa.id_crm_etapa === Number(idEtapa)
        );

        if (coluna) {
          return coluna.etapa;
        }
      }

      for (const funil of this.funis) {
        const etapas = funil.etapas || [];
        const etapa = etapas.find(
          (item) => item.id_crm_etapa === Number(idEtapa)
        );

        if (etapa) {
          return etapa;
        }
      }

      return null;
    },
    camposObrigatoriosEtapa(etapa, contexto = "entrada_etapa") {
      if (!etapa) {
        return [];
      }

      return (
        etapa.campos_obrigatorios ||
        etapa.camposObrigatorios ||
        []
      ).filter(
        (regra) =>
          regra.ativo !== false &&
          (!regra.contexto || regra.contexto === contexto)
      );
    },
    isEtapaApresentacaoTecnica(etapa) {
      if (!etapa) {
        return false;
      }

      return (
        etapa.chave_preset === "apresentacao_tecnica" ||
        this.slugEtapa(etapa.nome) === "apresentacao_tecnica"
      );
    },
    etapaPossuiChave(etapa, chave) {
      if (!etapa) {
        return false;
      }

      const chaves = [etapa.chave_preset, etapa.chave, etapa.nome].map(
        (valor) => this.slugEtapa(valor)
      );

      return chaves.includes(chave);
    },
    oportunidadeTemVendedorResponsavel(oportunidade = {}) {
      return !!(
        oportunidade &&
        (oportunidade.id_vendedor_responsavel ||
          this.valorCampoComercial(oportunidade, "id_vendedor_responsavel"))
      );
    },
    oportunidadeTemResponsavelTecnico(oportunidade = {}) {
      return !!(
        oportunidade &&
        (oportunidade.id_responsavel_tecnico ||
          this.valorCampoComercial(oportunidade, "id_responsavel_tecnico"))
      );
    },
    slugEtapa(nome) {
      return String(nome || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_|_$/g, "");
    },
    deveAbrirModalMovimento(
      etapa,
      oportunidade = this.oportunidadeSelecionada
    ) {
      return (
        this.camposObrigatoriosEtapa(etapa).length > 0 ||
        (!this.oportunidadeTemResponsavelTecnico(oportunidade) &&
          this.isEtapaApresentacaoTecnica(etapa))
      );
    },
    campoObrigatorioConfig(regra) {
      return regra.campo || regra.campo_comercial || {};
    },
    campoObrigatorioChave(regra) {
      return this.campoObrigatorioConfig(regra).chave || regra.chave || "";
    },
    campoObrigatorioTipo(regra) {
      return this.campoObrigatorioConfig(regra).tipo || regra.tipo || "texto";
    },
    isCampoObrigatorioMonetario(regra) {
      return [
        "valor_estimado",
        "valor_proposta",
        "valor_negociacao",
        "valor_final",
      ].includes(this.campoObrigatorioChave(regra));
    },
    labelCampoObrigatorio(regra) {
      return this.campoObrigatorioConfig(regra).nome || regra.nome || "Campo";
    },
    campoObrigatorioOptions(regra) {
      const opcoes = this.campoObrigatorioConfig(regra).opcoes || [];
      const valores = Array.isArray(opcoes)
        ? opcoes
        : this.parseCampoObrigatorioOpcoes(opcoes);

      return [{ value: null, text: "Selecione" }].concat(
        valores.map((valor) =>
          typeof valor === "object"
            ? {
                value: valor.value || valor.valor || valor.label,
                text: valor.label || valor.text || valor.valor,
              }
            : { value: valor, text: valor }
        )
      );
    },
    parseCampoObrigatorioOpcoes(opcoes) {
      const texto = String(opcoes || "");

      if (!texto) {
        return [];
      }

      try {
        const parsed = JSON.parse(texto);
        if (Array.isArray(parsed)) {
          return parsed;
        }
      } catch (error) {
        // Campo legado pode vir como texto livre separado por linha.
      }

      return texto.split("\n").filter(Boolean);
    },
    prepararCamposMovimento() {
      const form = {};

      this.camposObrigatoriosMovimento.forEach((regra) => {
        const idCampo = regra.id_crm_campo_comercial;
        let valor = this.movimentoCamposForm[idCampo] || "";

        if (
          this.movimentoManterValor &&
          this.campoObrigatorioChave(regra) === "valor_negociacao"
        ) {
          valor = this.valorPadraoNegociacao();
        }

        this.$set(form, idCampo, valor);
      });

      this.movimentoCamposForm = form;
    },
    valorPadraoNegociacao() {
      const valor =
        this.valorCampoComercial(
          this.oportunidadeSelecionada,
          "valor_proposta"
        ) || this.valorPrincipalOportunidade(this.oportunidadeSelecionada);

      return valor ? valor.toFixed(2) : "";
    },
    validarCamposMovimento() {
      if (this.movimentoExigeAtribuicao && !this.idUsuarioDestino) {
        this.$toast.error(
          "Selecione o vendedor responsável pela oportunidade."
        );
        return false;
      }

      if (this.movimentoExigeTecnico && !this.idUsuarioTecnicoDestino) {
        this.$toast.error(
          "Selecione o desenvolvedor responsável pela apresentação técnica."
        );
        return false;
      }

      if (this.usuarioDestinoSemAcesso && !this.concederAcessoFunilDestino) {
        this.$toast.error(
          "O usuário escolhido ainda não tem acesso ao funil atual."
        );
        return false;
      }

      const faltante = this.camposObrigatoriosMovimento.find((regra) => {
        const valor =
          this.movimentoCamposForm[regra.id_crm_campo_comercial] || "";
        return String(valor).trim() === "";
      });

      if (faltante) {
        this.$toast.error(
          faltante.mensagem ||
            `Preencha o campo obrigatório: ${this.labelCampoObrigatorio(
              faltante
            )}.`
        );
        return false;
      }

      return true;
    },
    movimentoCamposPayload() {
      return this.camposObrigatoriosMovimento.map((regra) => ({
        id_crm_campo_comercial: regra.id_crm_campo_comercial,
        valor: this.movimentoCamposForm[regra.id_crm_campo_comercial],
      }));
    },
    abrirModalMoverComDestino(oportunidade, idEtapaDestino) {
      this.oportunidadeSelecionada = oportunidade;
      this.idEtapaDestino = idEtapaDestino;
      this.idUsuarioTecnicoDestino = null;
      this.idUsuarioDestino = null;
      this.concederAcessoFunilDestino = false;
      this.movimentoCamposForm = {};
      this.movimentoManterValor = true;
      this.prepararCamposMovimento();
      this.$bvModal.show("crm-mover-oportunidade-modal");
    },
    abrirModalCriacao() {
      this.form = this.emptyForm();
      this.form.id_crm_funil =
        this.filtros.id_crm_funil ||
        (this.kanban ? this.kanban.funil.id_crm_funil : null);
      this.form.id_crm_etapa = null;
      this.vinculoSelecionado = null;
      this.wizardStep = 0;
      this.$bvModal.show("crm-funil-oportunidade-modal");
    },
    abrirModalEdicao(oportunidade) {
      this.$bvModal.hide("crm-funil-acoes-modal");
      this.form = {
        id_crm_oportunidade: oportunidade.id_crm_oportunidade,
        titulo: oportunidade.titulo,
        id_crm_funil: oportunidade.id_crm_funil,
        id_crm_etapa: oportunidade.id_crm_etapa,
        id_usuario: oportunidade.id_usuario,
        id_crm_fonte: oportunidade.id_crm_fonte || null,
        campanha: oportunidade.campanha || "",
        valor_estimado:
          oportunidade.valor_estimado ||
          this.valorPrincipalOportunidade(oportunidade),
        previsao_fechamento: oportunidade.previsao_fechamento,
        temperatura: oportunidade.temperatura || null,
        proxima_atividade_em: this.toDateTimeLocal(
          oportunidade.proxima_atividade_em
        ),
      };
      this.$bvModal.show("crm-funil-oportunidade-modal");
    },
    async salvarOportunidade(criarOutra = false) {
      const payload = {
        ...this.form,
        titulo: (this.form.titulo || "").trim(),
        campanha: this.form.campanha || null,
      };

      if (!payload.titulo) {
        this.$toast.error("Informe o título da oportunidade.");
        return;
      }

      if (!payload.id_crm_oportunidade) {
        if (!this.vinculoSelecionado) {
          this.$toast.error(
            "Informe um contato ou cliente para a oportunidade."
          );
          return;
        }
        if (!payload.id_crm_funil) {
          this.$toast.error("Selecione o funil da oportunidade.");
          return;
        }

        this.form.titulo = payload.titulo;
        delete payload.id_crm_etapa;
        payload.id_crm_contato = this.vinculoSelecionado.id_crm_contato;
        payload.id_pessoa = this.vinculoSelecionado.id_pessoa;
        this.savingOportunidade = true;

        try {
          const { data: oportunidadeCriada } =
            await crmService.criarOportunidade(payload);
          this.$toast.success("Oportunidade criada com sucesso.");

          if (criarOutra) {
            this.reiniciarWizardCriacao();
            this.loadKanban();
          } else {
            this.$bvModal.hide("crm-funil-oportunidade-modal");
            this.abrirOportunidadeCriada(oportunidadeCriada, "funil");
          }
        } finally {
          this.savingOportunidade = false;
        }
      } else {
        this.savingOportunidade = true;

        try {
          await crmService.atualizarOportunidade(payload);
          this.$toast.success("Oportunidade atualizada com sucesso.");
          this.$bvModal.hide("crm-funil-oportunidade-modal");
          this.loadKanban();
        } finally {
          this.savingOportunidade = false;
        }
      }
    },
    reiniciarWizardCriacao() {
      const idFunil = this.form.id_crm_funil;
      this.form = this.emptyForm();
      this.form.id_crm_funil = idFunil;
      this.vinculoSelecionado = null;
      this.wizardStep = 0;
    },
    abrirOportunidadeCriada(oportunidade, origem) {
      if (!oportunidade || !oportunidade.id_crm_oportunidade) {
        this.loadKanban();
        return;
      }

      this.$router
        .push({
          name: "crmOportunidadeDetalhe",
          params: { id: oportunidade.id_crm_oportunidade },
          query: { origem },
        })
        .catch(() => {});
    },
    fecharCriacaoMaisTarde() {
      this.$bvModal.hide("crm-funil-oportunidade-modal");
    },
    irParaWizardStep(index) {
      if (index <= this.wizardStep) {
        this.wizardStep = index;
        return;
      }

      while (this.wizardStep < index) {
        if (!this.validarWizardStep(this.wizardStep)) {
          return;
        }

        this.wizardStep += 1;
      }
    },
    avancarWizard() {
      if (!this.validarWizardStep(this.wizardStep)) {
        return;
      }

      this.wizardStep = Math.min(
        this.wizardStep + 1,
        this.wizardSteps.length - 1
      );
    },
    validarWizardStep(step) {
      if (step === 0 && !(this.form.titulo || "").trim()) {
        this.$toast.error("Informe o nome da negociação.");
        return false;
      }

      if (step === 1 && !this.vinculoSelecionado) {
        this.$toast.error("Selecione ou crie um contato com WhatsApp.");
        return false;
      }

      if (step === 2 && !this.form.id_crm_funil) {
        this.$toast.error("Selecione o funil da oportunidade.");
        return false;
      }

      return true;
    },
    async criarContatoRapido(payload) {
      const contatoPayload =
        typeof payload === "string"
          ? { nome: payload, origem_criacao_rapida: true }
          : { ...payload, origem_criacao_rapida: true };
      const { data } = await crmService.criarContato(contatoPayload);
      const contato = data.contato || data;
      this.vinculoSelecionado = {
        tipo: "contato",
        label: contato.nome,
        id_crm_contato: contato.id_crm_contato,
        id_pessoa: contato.id_pessoa || null,
        id_crm_oportunidade: null,
        raw: contato,
      };
      this.$toast.success("Contato criado e selecionado.");
    },
    abrirDetalhe(oportunidade) {
      this.$bvModal.hide("crm-funil-acoes-modal");
      this.$router.push({
        name: "crmOportunidadeDetalhe",
        params: { id: oportunidade.id_crm_oportunidade },
        query: { origem: "funil" },
      });
    },
    abrirModalMover(oportunidade) {
      this.$bvModal.hide("crm-funil-acoes-modal");
      this.oportunidadeSelecionada = oportunidade;
      this.idEtapaDestino = oportunidade.id_crm_etapa;
      this.idUsuarioTecnicoDestino = null;
      this.idUsuarioDestino = null;
      this.concederAcessoFunilDestino = false;
      this.movimentoCamposForm = {};
      this.movimentoManterValor = true;
      this.prepararCamposMovimento();
      this.$bvModal.show("crm-mover-oportunidade-modal");
    },
    abrirModalAcoes(oportunidade) {
      this.oportunidadeSelecionada = oportunidade;
      this.$bvModal.show("crm-funil-acoes-modal");
    },
    abrirModalTemperatura(oportunidade) {
      this.oportunidadeSelecionada = oportunidade;
      this.temperaturaForm = {
        temperatura: oportunidade.temperatura || null,
      };
      this.$bvModal.show("crm-funil-temperatura-modal");
    },
    async salvarTemperaturaOportunidade() {
      if (!this.oportunidadeSelecionada.id_crm_oportunidade) {
        return;
      }

      try {
        await crmService.atualizarOportunidade({
          id_crm_oportunidade: this.oportunidadeSelecionada.id_crm_oportunidade,
          temperatura: this.temperaturaForm.temperatura || null,
        });
        this.atualizarTemperaturaVisual(
          this.oportunidadeSelecionada.id_crm_oportunidade,
          this.temperaturaForm.temperatura || null
        );
        this.$toast.success("Temperatura atualizada.");
        this.$bvModal.hide("crm-funil-temperatura-modal");
        this.loadKanban();
      } catch (error) {
        this.$toast.error(
          this.apiError(error, "Não foi possível atualizar a temperatura.")
        );
      }
    },
    atualizarTemperaturaVisual(idOportunidade, temperatura) {
      if (!this.kanban || !Array.isArray(this.kanban.colunas)) {
        return;
      }

      this.kanban.colunas.forEach((coluna) => {
        coluna.oportunidades.forEach((oportunidade) => {
          if (
            Number(oportunidade.id_crm_oportunidade) === Number(idOportunidade)
          ) {
            this.$set(oportunidade, "temperatura", temperatura);
          }
        });
      });

      if (
        this.oportunidadeSelecionada &&
        Number(this.oportunidadeSelecionada.id_crm_oportunidade) ===
          Number(idOportunidade)
      ) {
        this.oportunidadeSelecionada = {
          ...this.oportunidadeSelecionada,
          temperatura,
        };
      }
    },
    temperaturaIcon(valor) {
      const icons = {
        muito_frio: "la la-thermometer-empty",
        frio: "la la-thermometer-quarter",
        morno: "la la-thermometer-half",
        quente: "la la-thermometer-three-quarters",
        venda_certa: "la la-thermometer-full",
      };

      return icons[valor] || "la la-thermometer-empty";
    },
    temperaturaColor(valor) {
      const option = this.temperaturaOptions.find(
        (item) => item.value === valor
      );

      return option && option.cor ? option.cor : "#7e8299";
    },
    isContrato(oportunidade) {
      return oportunidade && oportunidade.tipo_fluxo === "contratos";
    },
    isVendaClienteFinal(oportunidade) {
      if (oportunidade && oportunidade.tipo_fluxo === "vendas_cliente_final") {
        return true;
      }

      const idFunil = oportunidade ? oportunidade.id_crm_funil : null;
      const funil =
        this.funis.find(
          (item) => Number(item.id_crm_funil) === Number(idFunil)
        ) ||
        (this.kanban &&
        this.kanban.funil &&
        Number(this.kanban.funil.id_crm_funil) === Number(idFunil)
          ? this.kanban.funil
          : null);

      return funil && funil.chave_preset === "vendas_cliente_final";
    },
    clienteContrato(oportunidade) {
      return (
        oportunidade.pessoa || oportunidade.contato || "Cliente não informado"
      );
    },
    telefoneContrato(oportunidade) {
      return (
        oportunidade.contato_telefone ||
        oportunidade.telefone_contato ||
        oportunidade.pessoa_telefone ||
        ""
      );
    },
    emailContrato(oportunidade) {
      return oportunidade.contato_email || oportunidade.pessoa_email || "";
    },
    beneficiosOportunidade(oportunidade) {
      const estruturados = this.beneficiosEstruturadosOportunidade(oportunidade)
        .map((item) => this.beneficioLabel(item))
        .filter(Boolean)
        .join(", ");
      const livres = this.beneficiosLivresOportunidade(oportunidade);

      return [estruturados, livres].filter(Boolean).join(" | ");
    },
    beneficiosLivresOportunidade(oportunidade) {
      const campos = Array.isArray(oportunidade.campos_comerciais)
        ? oportunidade.campos_comerciais
        : [];
      const campoLivres = campos.find(
        (item) => item.chave === "beneficios_livres"
      );
      const campoLegado = campos.find((item) => item.chave === "beneficios");
      return String(
        oportunidade.beneficios_livres ||
          oportunidade.beneficios ||
          (campoLivres ? campoLivres.valor : "") ||
          (campoLegado ? campoLegado.valor : "") ||
          ""
      ).trim();
    },
    beneficiosEstruturadosOportunidade(oportunidade) {
      const campos = Array.isArray(oportunidade.campos_comerciais)
        ? oportunidade.campos_comerciais
        : [];
      const campoEstruturado = campos.find(
        (item) => item.chave === "beneficios_estruturados"
      );
      const valorEstruturado =
        oportunidade.beneficios_estruturados ||
        (campoEstruturado ? campoEstruturado.valor : "");
      const estruturados = this.beneficiosEstruturadosLista(valorEstruturado);

      if (estruturados.length || campoEstruturado) {
        return estruturados;
      }

      return this.beneficiosEstruturadosLista(
        oportunidade.beneficios ||
          this.beneficiosLivresOportunidade(oportunidade)
      );
    },
    abrirDadosNegociacao(oportunidade) {
      this.$bvModal.hide("crm-funil-acoes-modal");
      this.dadosNegociacao = {
        cliente: this.clienteContrato(oportunidade),
        origem: oportunidade.oportunidade_origem || oportunidade.titulo || "-",
        valor: this.valorPrincipalOportunidade(oportunidade),
        telefone: this.telefoneContrato(oportunidade),
        email: this.emailContrato(oportunidade),
        beneficios: this.beneficiosOportunidade(oportunidade),
      };
      this.$bvModal.show("crm-dados-negociacao-modal");
    },
    enviarContratoWhatsapp(oportunidade) {
      const telefone = this.normalizarTelefoneWhatsapp(
        oportunidade.contato_telefone_normalizado ||
          this.telefoneContrato(oportunidade)
      );

      if (!telefone) {
        this.$toast.error("Telefone não informado para enviar o contrato.");
        return;
      }

      const mensagem = `Olá ${this.clienteContrato(
        oportunidade
      )}, segue o contrato referente à negociação ${oportunidade.titulo}.`;
      window.open(
        `https://web.whatsapp.com/send?phone=${telefone}&text=${encodeURIComponent(
          mensagem
        )}`,
        "_blank",
        "noopener"
      );
    },
    enviarContratoEmail(oportunidade) {
      const email = this.emailContrato(oportunidade);

      if (!email) {
        this.$toast.error("E-mail não informado para enviar o contrato.");
        return;
      }

      const assunto = `Contrato - ${this.clienteContrato(oportunidade)}`;
      const corpo = `Olá,\n\nSegue o contrato referente à negociação ${
        oportunidade.titulo
      }.\n\nValor negociado: ${this.formatMoney(
        this.valorPrincipalOportunidade(oportunidade)
      )}.\n`;
      window.location.href = `mailto:${email}?subject=${encodeURIComponent(
        assunto
      )}&body=${encodeURIComponent(corpo)}`;
    },
    normalizarTelefoneWhatsapp(value) {
      let telefone = String(value || "").replace(/\D+/g, "");

      if (!telefone) {
        return "";
      }

      if (!telefone.startsWith("55") && telefone.length <= 11) {
        telefone = `55${telefone}`;
      }

      return telefone;
    },
    abrirModalTarefa(oportunidade, sugestao = null) {
      this.oportunidadeSelecionada = oportunidade;
      this.tarefaForm = this.emptyTarefaForm();
      this.tarefaForm.id_usuario = oportunidade.id_usuario;
      this.tarefaForm.tipo =
        sugestao && sugestao.tipo
          ? sugestao.tipo
          : this.tipoTarefaOptions.length
          ? this.tipoTarefaOptions[0].value
          : "tarefa";
      this.tarefaForm.titulo =
        sugestao && sugestao.titulo
          ? sugestao.titulo
          : `Follow-up - ${oportunidade.titulo}`;

      if (sugestao && sugestao.prazo_horas !== null) {
        const vencimento = new Date();
        vencimento.setHours(
          vencimento.getHours() + Number(sugestao.prazo_horas || 0)
        );
        this.tarefaForm.vencimento_em = this.toDateTimeLocal(vencimento);
      }

      this.tarefaDrawerVisible = true;
    },
    async criarTarefa(agendar = false) {
      if (!this.tarefaForm.titulo) {
        this.$toast.error("Informe o título da tarefa.");
        return;
      }

      const response = await crmService.criarAtividade({
        ...this.tarefaForm,
        id_crm_oportunidade: this.oportunidadeSelecionada.id_crm_oportunidade,
        id_crm_contato: this.oportunidadeSelecionada.id_crm_contato,
        vencimento_em: this.fromDateTimeLocal(this.tarefaForm.vencimento_em),
      });
      const atividade = this.responseData(response);
      this.$toast.success("Tarefa criada com sucesso.");
      this.tarefaDrawerVisible = false;

      if (agendar) {
        this.abrirModalAgenda(this.oportunidadeSelecionada, atividade);
      }

      this.loadKanban();
    },
    abrirModalAgenda(oportunidade, tarefa = null) {
      this.oportunidadeSelecionada = oportunidade;
      this.agendaForm = this.emptyAgendaForm();
      this.agendaForm.id_usuario = this.isTreinamentoClienteFinal(oportunidade)
        ? this.idPrimeiroResponsavelTreinamento()
        : oportunidade.id_usuario;
      this.agendaForm.titulo = this.isTreinamentoClienteFinal(oportunidade)
        ? `Treinamento - ${oportunidade.titulo}`
        : `Agenda - ${oportunidade.titulo}`;
      this.agendaForm.tipo = this.isTreinamentoClienteFinal(oportunidade)
        ? "treinamento_cliente_final"
        : this.agendaForm.tipo;
      this.agendaForm.descricao = this.isTreinamentoClienteFinal(oportunidade)
        ? "Agendamento criado a partir do funil Treinamento Cliente Final."
        : this.agendaForm.descricao;
      this.tarefaAgendamentoOrigem = tarefa;

      if (tarefa) {
        this.preencherAgendaPorTarefa(tarefa);
      }

      this.agendaHorarios = null;
      this.agendaHorariosErro = "";
      this.agendaDrawerVisible = true;
    },
    preencherAgendaPorTarefa(tarefa) {
      const treinamentoClienteFinal = this.isTreinamentoClienteFinal(
        this.oportunidadeSelecionada
      );
      this.agendaForm.id_crm_atividade = tarefa.id_crm_atividade || null;
      this.agendaForm.titulo = treinamentoClienteFinal
        ? `Treinamento - ${this.oportunidadeSelecionada.titulo}`
        : `Tarefa - ${tarefa.titulo}`;
      this.agendaForm.id_usuario = treinamentoClienteFinal
        ? this.agendaForm.id_usuario ||
          this.idPrimeiroResponsavelTreinamento() ||
          tarefa.id_usuario ||
          this.oportunidadeSelecionada.id_usuario
        : tarefa.id_usuario || this.oportunidadeSelecionada.id_usuario;
      this.agendaForm.tipo = treinamentoClienteFinal
        ? "treinamento_cliente_final"
        : this.agendaForm.tipo;
      this.agendaForm.data_inicio = tarefa.vencimento_em
        ? this.toDateTimeLocal(tarefa.vencimento_em)
        : this.agendaForm.data_inicio;
      this.agendaForm.descricao = [
        `Tarefa: ${tarefa.titulo}`,
        `Tipo: ${this.tipoTarefaLabel(tarefa.tipo)}`,
        tarefa.descricao ? `Descrição: ${tarefa.descricao}` : null,
      ]
        .filter(Boolean)
        .join("\n");
    },
    async buscarHorariosAgenda() {
      if (!this.agendaForm.id_usuario) {
        this.$toast.error("Selecione o responsável.");
        return;
      }

      this.loadingAgendaHorarios = true;
      this.agendaHorariosErro = "";

      try {
        const { data } = await crmService.horariosDisponiveisAgenda({
          data: this.dateFromDateTimeLocal(this.agendaForm.data_inicio),
          id_usuario: this.agendaForm.id_usuario,
          id_crm_oportunidade: this.oportunidadeSelecionada
            ? this.oportunidadeSelecionada.id_crm_oportunidade
            : null,
          id_crm_atividade: this.agendaForm.id_crm_atividade,
          duracao_minutos: Number(this.agendaForm.duracao_minutos || 30),
        });
        this.agendaHorarios = data;
      } catch (error) {
        this.agendaHorarios = null;
        this.agendaHorariosErro = this.apiError(
          error,
          "Não foi possível buscar os horários."
        );
      } finally {
        this.loadingAgendaHorarios = false;
      }
    },
    resetAgendaHorarios() {
      if (!this.agendaDrawerVisible) {
        return;
      }

      this.agendaHorarios = null;
      this.agendaHorariosErro = "";
    },
    selecionarHorarioAgenda(slot) {
      if (!slot.disponivel) {
        return;
      }

      this.agendaForm.data_inicio = this.toDateTimeLocal(slot.inicio);
    },
    agendaSlotSelecionado(slot) {
      return this.agendaForm.data_inicio === this.toDateTimeLocal(slot.inicio);
    },
    async criarAgenda() {
      if (!this.agendaForm.titulo || !this.agendaForm.data_inicio) {
        this.$toast.error("Informe o título e a data da agenda.");
        return;
      }

      await crmService.criarAgendamento({
        ...this.agendaForm,
        id_crm_oportunidade: this.oportunidadeSelecionada.id_crm_oportunidade,
        id_crm_contato: this.oportunidadeSelecionada.id_crm_contato,
        id_crm_atividade: this.agendaForm.id_crm_atividade,
        observacoes: this.tarefaAgendamentoOrigem
          ? `Agendamento criado a partir da tarefa #${this.tarefaAgendamentoOrigem.id_crm_atividade}: ${this.tarefaAgendamentoOrigem.titulo}`
          : this.agendaForm.descricao,
        data_inicio: this.fromDateTimeLocal(this.agendaForm.data_inicio),
      });
      this.$toast.success(
        this.isTreinamentoClienteFinal(this.oportunidadeSelecionada)
          ? "Treinamento agendado e enviado ao funil Treinamento."
          : "Agendamento CRM criado com sucesso."
      );
      this.agendaDrawerVisible = false;
      this.tarefaAgendamentoOrigem = null;
      this.loadKanban();
    },
    abrirModalNota(oportunidade) {
      this.oportunidadeSelecionada = oportunidade;
      this.notaForm = this.emptyNotaForm();
      this.$bvModal.show("crm-funil-nota-modal");
    },
    async adicionarNota() {
      if (!this.notaForm.descricao) {
        this.$toast.error("Informe a nota.");
        return;
      }

      await crmService.adicionarNota({
        id_crm_oportunidade: this.oportunidadeSelecionada.id_crm_oportunidade,
        id_crm_contato: this.oportunidadeSelecionada.id_crm_contato,
        descricao: this.notaForm.descricao,
      });
      this.$toast.success("Nota adicionada com sucesso.");
      this.$bvModal.hide("crm-funil-nota-modal");
      this.loadKanban();
    },
    async moverOportunidade() {
      if (
        !this.idEtapaDestino ||
        this.idEtapaDestino === this.oportunidadeSelecionada.id_crm_etapa
      ) {
        this.$bvModal.hide("crm-mover-oportunidade-modal");
        return;
      }

      this.prepararCamposMovimento();

      if (!this.validarCamposMovimento()) {
        return;
      }

      const snapshot = JSON.parse(JSON.stringify(this.kanban));
      const movimento = this.aplicarMovimentoVisual(
        this.oportunidadeSelecionada,
        this.idEtapaDestino
      );

      try {
        await crmService.moverEtapa({
          id_crm_oportunidade: this.oportunidadeSelecionada.id_crm_oportunidade,
          id_crm_etapa: this.idEtapaDestino,
          id_usuario_tecnico: this.movimentoExigeTecnico
            ? this.idUsuarioTecnicoDestino
            : null,
          id_usuario_destino: this.movimentoExigeAtribuicao
            ? this.idUsuarioDestino
            : null,
          id_vendedor_responsavel: this.movimentoExigeAtribuicao
            ? this.idUsuarioDestino
            : null,
          conceder_acesso_funil: this.concederAcessoFunilDestino,
          campos_comerciais: this.movimentoCamposPayload(),
        });
        this.sincronizarOportunidadeSelecionada(movimento.oportunidade);
        this.$toast.success("Oportunidade movida com sucesso.");
        this.$bvModal.hide("crm-mover-oportunidade-modal");
        this.sugerirTarefaDaEtapa(movimento.destino, movimento.oportunidade);
        this.loadKanban();
      } catch (error) {
        this.kanban = snapshot;
        this.$toast.error(
          this.apiError(error, "Não foi possível mover a oportunidade.")
        );
      }
    },
    async moverOportunidadeDoCard({ oportunidade, id_crm_etapa }) {
      if (!id_crm_etapa || id_crm_etapa === oportunidade.id_crm_etapa) {
        return;
      }

      const etapaDestino = this.findEtapaById(id_crm_etapa);

      if (this.deveAbrirModalMovimento(etapaDestino, oportunidade)) {
        this.abrirModalMoverComDestino(oportunidade, id_crm_etapa);
        return;
      }

      const etapaOrigem = this.findEtapaById(oportunidade.id_crm_etapa);
      if (
        !this.oportunidadeTemVendedorResponsavel(oportunidade) &&
        this.etapaPossuiChave(etapaOrigem, "primeiro_contato") &&
        this.etapaPossuiChave(etapaDestino, "qualificacao")
      ) {
        this.abrirModalMoverComDestino(oportunidade, id_crm_etapa);
        return;
      }

      const snapshot = JSON.parse(JSON.stringify(this.kanban));
      const movimento = this.aplicarMovimentoVisual(oportunidade, id_crm_etapa);

      try {
        await crmService.moverEtapa({
          id_crm_oportunidade: oportunidade.id_crm_oportunidade,
          id_crm_etapa,
        });

        this.sincronizarOportunidadeSelecionada(movimento.oportunidade);
        this.$toast.success("Etapa alterada.");
        this.sugerirTarefaDaEtapa(movimento.destino, movimento.oportunidade);
        this.loadKanban();
      } catch (error) {
        this.kanban = snapshot;
        this.$toast.error(
          this.apiError(error, "Não foi possível alterar a etapa.")
        );
      }
    },
    aplicarMovimentoVisual(oportunidade, idEtapaDestino) {
      const origem = this.kanban.colunas.find(
        (coluna) => coluna.etapa.id_crm_etapa === oportunidade.id_crm_etapa
      );
      const destino = this.kanban.colunas.find(
        (coluna) => coluna.etapa.id_crm_etapa === idEtapaDestino
      );

      if (!origem || !destino) {
        return {
          origem: null,
          destino: null,
          oportunidade,
        };
      }

      origem.oportunidades = origem.oportunidades.filter(
        (item) => item.id_crm_oportunidade !== oportunidade.id_crm_oportunidade
      );
      origem.total = Math.max(Number(origem.total || 0) - 1, 0);
      const valorOportunidade = this.valorPrincipalOportunidade(oportunidade);
      origem.valor_total = Math.max(
        Number(origem.valor_total || 0) - valorOportunidade,
        0
      );

      const oportunidadeMovida = {
        ...oportunidade,
        id_crm_etapa: idEtapaDestino,
        etapa: destino.etapa.nome,
      };

      destino.oportunidades.unshift(oportunidadeMovida);
      destino.total = Number(destino.total || 0) + 1;
      destino.valor_total =
        Number(destino.valor_total || 0) + valorOportunidade;

      return {
        origem,
        destino,
        oportunidade: oportunidadeMovida,
      };
    },
    sugerirTarefaDaEtapa(destino, oportunidade) {
      const etapa = destino && destino.etapa ? destino.etapa : {};

      if (!etapa.sugerir_tarefa) {
        return;
      }

      this.abrirModalTarefa(oportunidade, {
        tipo: etapa.tarefa_sugerida_tipo || "tarefa",
        titulo:
          etapa.tarefa_sugerida_titulo || `Follow-up - ${oportunidade.titulo}`,
        prazo_horas:
          etapa.tarefa_sugerida_prazo_horas === null
            ? null
            : etapa.tarefa_sugerida_prazo_horas || 24,
      });
      this.$toast.warning("Tarefa sugerida pela etapa.");
    },
    iniciarDrag(oportunidade) {
      this.dragState = {
        oportunidade,
        origemId: oportunidade.id_crm_etapa,
        destinoId: null,
        moving: false,
      };
    },
    encerrarDrag() {
      if (this.dragState.moving) {
        return;
      }

      this.dragState = this.emptyDragState();
    },
    marcarColunaDrop(coluna) {
      if (!this.dragState.oportunidade || this.dragState.moving) {
        return;
      }

      this.dragState.destinoId = coluna.etapa.id_crm_etapa;
    },
    limparColunaDrop(coluna, event) {
      if (!this.dragState.oportunidade || this.dragState.moving) {
        return;
      }

      if (event.currentTarget.contains(event.relatedTarget)) {
        return;
      }

      if (this.dragState.destinoId === coluna.etapa.id_crm_etapa) {
        this.dragState.destinoId = null;
      }
    },
    colunaDropAtiva(coluna) {
      return (
        this.dragState.destinoId === coluna.etapa.id_crm_etapa &&
        this.dragState.origemId !== coluna.etapa.id_crm_etapa
      );
    },
    colunaDragOrigem(coluna) {
      return this.dragState.origemId === coluna.etapa.id_crm_etapa;
    },
    oportunidadeEmDrag(oportunidade) {
      return (
        this.dragState.oportunidade &&
        this.dragState.oportunidade.id_crm_oportunidade ===
          oportunidade.id_crm_oportunidade
      );
    },
    async soltarOportunidade(coluna) {
      if (!this.dragState.oportunidade || this.dragState.moving) {
        return;
      }

      const oportunidade = this.dragState.oportunidade;
      const idEtapaDestino = coluna.etapa.id_crm_etapa;

      if (idEtapaDestino === oportunidade.id_crm_etapa) {
        this.dragState = this.emptyDragState();
        return;
      }

      if (this.deveAbrirModalMovimento(coluna.etapa, oportunidade)) {
        this.dragState = this.emptyDragState();
        this.abrirModalMoverComDestino(oportunidade, idEtapaDestino);
        return;
      }

      const etapaOrigem = this.findEtapaById(oportunidade.id_crm_etapa);
      if (
        !this.oportunidadeTemVendedorResponsavel(oportunidade) &&
        this.etapaPossuiChave(etapaOrigem, "primeiro_contato") &&
        this.etapaPossuiChave(coluna.etapa, "qualificacao")
      ) {
        this.dragState = this.emptyDragState();
        this.abrirModalMoverComDestino(oportunidade, idEtapaDestino);
        return;
      }

      const snapshot = JSON.parse(JSON.stringify(this.kanban));
      this.dragState = {
        ...this.dragState,
        destinoId: idEtapaDestino,
        moving: true,
      };

      const movimento = this.aplicarMovimentoVisual(
        oportunidade,
        idEtapaDestino
      );

      try {
        await crmService.moverEtapa({
          id_crm_oportunidade: oportunidade.id_crm_oportunidade,
          id_crm_etapa: idEtapaDestino,
        });

        this.sincronizarOportunidadeSelecionada(movimento.oportunidade);
        this.$toast.success("Etapa alterada.");
      } catch (error) {
        this.kanban = snapshot;
        this.$toast.error(
          this.apiError(error, "Não foi possível alterar a etapa.")
        );
      } finally {
        this.dragState = this.emptyDragState();
      }
    },
    sincronizarOportunidadeSelecionada(oportunidade) {
      if (
        this.oportunidadeSelecionada &&
        this.oportunidadeSelecionada.id_crm_oportunidade ===
          oportunidade.id_crm_oportunidade
      ) {
        this.oportunidadeSelecionada = oportunidade;
      }
    },
    async carregarMais(coluna) {
      const idEtapa = coluna.etapa.id_crm_etapa;
      this.$set(this.loadingEtapas, idEtapa, true);

      try {
        const { data } = await crmService.kanban(
          this.buildKanbanParams({
            offsets: {
              [idEtapa]: coluna.oportunidades.length,
            },
          })
        );
        const novaColuna = data.colunas.find(
          (item) => item.etapa.id_crm_etapa === idEtapa
        );

        if (novaColuna) {
          coluna.oportunidades = coluna.oportunidades.concat(
            novaColuna.oportunidades
          );
          coluna.total = novaColuna.total;
          coluna.valor_total = novaColuna.valor_total;
        }
      } finally {
        this.$set(this.loadingEtapas, idEtapa, false);
      }
    },
    abrirModalGanho(oportunidade) {
      this.$bvModal.hide("crm-funil-acoes-modal");
      this.oportunidadeSelecionada = oportunidade;
      const clienteFinal = this.isVendaClienteFinal(oportunidade);
      const enderecoPessoa = this.enderecoPessoaOportunidade(oportunidade);
      this.ganho = {
        ...this.emptyGanho(),
        id_crm_oportunidade: oportunidade.id_crm_oportunidade,
        titulo: oportunidade.titulo || "",
        cliente:
          oportunidade.pessoa ||
          oportunidade.contato ||
          "Cliente sem nome cadastrado",
        nome_correto:
          oportunidade.pessoa ||
          oportunidade.contato ||
          oportunidade.titulo ||
          "",
        cnpj:
          oportunidade.pessoa_cnpj_cpf || oportunidade.contato_documento || "",
        email_cliente: oportunidade.contato_email || "",
        telefone_cliente:
          oportunidade.contato_telefone ||
          oportunidade.telefone_contato ||
          oportunidade.pessoa_telefone ||
          "",
        endereco_cliente:
          this.valorCampoComercial(oportunidade, "endereco_cliente") ||
          this.enderecoFechamentoCompleto(enderecoPessoa),
        ...enderecoPessoa,
        valor_final: this.valorPrincipalOportunidade(oportunidade),
        beneficios: this.beneficiosLivresOportunidade(oportunidade),
        beneficios_livres: this.beneficiosLivresOportunidade(oportunidade),
        beneficios_estruturados: clienteFinal
          ? ["treinamento_cliente_final"]
          : this.beneficiosEstruturadosOportunidade(oportunidade),
        cliente_final: clienteFinal,
      };
      this.$bvModal.show("crm-ganhar-oportunidade-modal");
    },
    validarGanho() {
      this.ganho.endereco_cliente = this.enderecoFechamentoCompleto(this.ganho);

      if (!(this.ganho.nome_correto || "").trim()) {
        this.$toast.error("Informe o nome correto do cliente.");
        return false;
      }

      if (this.somenteNumeros(this.ganho.cnpj).length !== 14) {
        this.$toast.error("Informe um CNPJ válido.");
        return false;
      }

      if (!(this.ganho.email_cliente || "").trim()) {
        this.$toast.error("Informe o e-mail do cliente.");
        return false;
      }

      if (!this.validarEnderecoGanho(this.ganho)) {
        return false;
      }

      if (Number(this.ganho.valor_final || 0) <= 0) {
        this.$toast.error("Informe o valor final.");
        return false;
      }

      if (
        !this.ganho.cliente_final &&
        !this.beneficiosEstruturadosLista(this.ganho.beneficios_estruturados)
          .length
      ) {
        this.$toast.error("Selecione pelo menos um benefício de regra.");
        return false;
      }

      return true;
    },
    async marcarGanha() {
      if (!this.validarGanho()) {
        return;
      }

      await crmService.marcarGanha({
        id_crm_oportunidade: this.ganho.id_crm_oportunidade,
        fechamento: {
          nome_correto: (this.ganho.nome_correto || "").trim(),
          cnpj: this.ganho.cnpj,
          email_cliente: (this.ganho.email_cliente || "").trim(),
          telefone_cliente: (this.ganho.telefone_cliente || "").trim(),
          endereco_cliente: (this.ganho.endereco_cliente || "").trim(),
          cep: this.ganho.cep,
          logradouro: this.ganho.logradouro,
          numero: this.ganho.numero,
          bairro: this.ganho.bairro,
          complemento: this.ganho.complemento,
          id_cidade: this.ganho.id_cidade,
          valor_final: Number(this.ganho.valor_final || 0),
          beneficios: (this.ganho.beneficios_livres || "").trim(),
          beneficios_livres: (this.ganho.beneficios_livres || "").trim(),
          beneficios_estruturados: this.ganho.cliente_final
            ? ["treinamento_cliente_final"]
            : this.beneficiosEstruturadosLista(
                this.ganho.beneficios_estruturados
              ),
        },
      });
      this.$toast.success("Oportunidade marcada como ganha.");
      this.$bvModal.hide("crm-ganhar-oportunidade-modal");
      this.loadKanban();
    },
    abrirModalPerda(oportunidade) {
      this.$bvModal.hide("crm-funil-acoes-modal");
      this.perda = this.emptyPerda();
      this.perda.id_crm_oportunidade = oportunidade.id_crm_oportunidade;
      this.$bvModal.show("crm-perder-oportunidade-modal");
    },
    async marcarPerdida() {
      if (!this.perda.id_crm_motivo_perda) {
        this.$toast.error("Informe o motivo da perda.");
        return;
      }

      await crmService.marcarPerdida(this.perda);
      this.$toast.success("Oportunidade marcada como perdida.");
      this.$bvModal.hide("crm-perder-oportunidade-modal");
      this.loadKanban();
    },
    proximaAcao(oportunidade) {
      if (!oportunidade.proxima_atividade_em) {
        return "Sem próxima ação";
      }

      return `Próxima ação: ${this.formatDateTime(
        oportunidade.proxima_atividade_em
      )}`;
    },
    oportunidadeAtrasada(oportunidade) {
      return (
        oportunidade.proxima_atividade_em &&
        new Date(oportunidade.proxima_atividade_em) < new Date()
      );
    },
    statusClass(status) {
      if (status === "ganha") {
        return "label-light-success";
      }

      if (status === "perdida") {
        return "label-light-danger";
      }

      return "label-light-primary";
    },
    statusLabel(status) {
      const labels = {
        aberta: "Aberta",
        ganha: "Ganha",
        perdida: "Perdida",
      };

      return labels[status] || status || "-";
    },
    tipoTarefaLabel(chave) {
      const tipo = this.tiposTarefa.find((item) => item.chave === chave);
      return tipo ? tipo.nome : chave || "-";
    },
    formatMoney(value) {
      return Number(value || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    valorPrincipalOportunidade(oportunidade = {}) {
      const campos = [
        oportunidade.valor_principal,
        oportunidade.valor_final,
        oportunidade.valor_negociacao,
        oportunidade.valor_proposta,
        oportunidade.valor_estimado,
      ];
      const valor = campos.find(
        (item) => item !== null && item !== undefined && item !== ""
      );

      return Number(valor || 0);
    },
    valorCampoComercial(oportunidade = {}, chave) {
      if (oportunidade[chave] !== null && oportunidade[chave] !== undefined) {
        return Number(oportunidade[chave] || 0);
      }

      const campos = Array.isArray(oportunidade.campos_comerciais)
        ? oportunidade.campos_comerciais
        : [];
      const campo = campos.find((item) => item.chave === chave);

      return campo && campo.valor !== "" && campo.valor !== null
        ? Number(campo.valor || 0)
        : 0;
    },
    beneficiosTexto(value) {
      let valores = value;

      if (typeof valores === "string") {
        const trimmed = valores.trim();
        if (!trimmed) {
          return "";
        }

        try {
          const parsed = JSON.parse(trimmed);
          valores = Array.isArray(parsed) ? parsed : trimmed;
        } catch (error) {
          valores = trimmed;
        }
      }

      if (!Array.isArray(valores)) {
        valores = String(valores || "")
          .split(/[,;\n]+/)
          .map((item) => item.trim());
      }

      return valores
        .map((item) => this.beneficioLabel(item))
        .filter(Boolean)
        .filter((item, index, array) => array.indexOf(item) === index)
        .filter((item, index, array) =>
          array.includes("Treinamento Cliente Final")
            ? item !== "Treinamento"
            : true
        )
        .join(", ");
    },
    beneficioLabel(value) {
      const text = String(value || "").trim();
      if (!text) {
        return "";
      }

      const key = text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");
      const labels = {
        website: "Website",
        web_site: "Website",
        site: "Website",
        treinamento: "Treinamento",
        treinamento_cliente_final: "Treinamento Cliente Final",
        treinamento_final: "Treinamento Cliente Final",
        cliente_final: "Treinamento Cliente Final",
        desconto: "Desconto",
        implantacao: "Implementação White Label",
        implementacao: "Implementação White Label",
        implantacao_white_label: "Implementação White Label",
        implementacao_white_label: "Implementação White Label",
        white_label: "Implementação White Label",
        suporte_estendido: "Suporte estendido",
      };

      return labels[key] || text.replace(/_/g, " ");
    },
    beneficioKey(value) {
      const text = String(value || "").trim();
      if (!text) {
        return "";
      }

      const key = text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");
      const keys = {
        website: "website",
        web_site: "website",
        site: "website",
        implantacao: "implementacao_white_label",
        implementacao: "implementacao_white_label",
        implantacao_white_label: "implementacao_white_label",
        implementacao_white_label: "implementacao_white_label",
        white_label: "implementacao_white_label",
        treinamento_cliente_final: "treinamento_cliente_final",
        treinamento_final: "treinamento_cliente_final",
        cliente_final: "treinamento_cliente_final",
      };

      return keys[key] || "";
    },
    beneficiosEstruturadosLista(value) {
      let valores = value;

      if (typeof valores === "string") {
        const trimmed = valores.trim();
        if (!trimmed) {
          return [];
        }

        try {
          const parsed = JSON.parse(trimmed);
          valores = Array.isArray(parsed) ? parsed : trimmed;
        } catch (error) {
          valores = trimmed;
        }
      }

      if (!Array.isArray(valores)) {
        valores = String(valores || "")
          .split(/[,;\n]+/)
          .map((item) => item.trim());
      }

      const permitidos = this.beneficioOptions.map((item) => item.value);
      return valores
        .map((item) => this.beneficioKey(item))
        .filter((item) => permitidos.includes(item))
        .filter((item, index, array) => array.indexOf(item) === index);
    },
    beneficioEstruturadoSelecionado(value) {
      return this.beneficiosEstruturadosLista(
        this.ganho.beneficios_estruturados
      ).includes(value);
    },
    toggleBeneficioGanho(value) {
      const key = this.beneficioKey(value);
      if (!key) {
        return;
      }

      let atuais = this.beneficiosEstruturadosLista(
        this.ganho.beneficios_estruturados
      );

      if (atuais.includes(key)) {
        this.ganho.beneficios_estruturados = atuais.filter(
          (item) => item !== key
        );
        return;
      }

      if (key === "treinamento_cliente_final") {
        this.ganho.beneficios_estruturados = [key];
        return;
      }

      atuais = atuais.filter((item) => item !== "treinamento_cliente_final");
      atuais.push(key);
      this.ganho.beneficios_estruturados = atuais;
    },
    adicionarBeneficioGanho(label) {
      this.toggleBeneficioGanho(label);
    },
    async consultarCnpjFechamento() {
      if (this.somenteNumeros(this.ganho.cnpj).length !== 14) {
        this.$toast.warning("Informe um CNPJ válido para consultar.");
        return;
      }

      this.loadingConsultaCnpjFechamento = true;

      try {
        const receita = await this.getConsultaReceita(this.ganho.cnpj);
        this.aplicarReceitaFechamento(receita);
        this.$toast.success(
          "Dados do CNPJ carregados. Confira antes de fechar."
        );
      } catch (error) {
        this.$toast.warning(
          this.apiError(error, "Não foi possível consultar o CNPJ.")
        );
      } finally {
        this.loadingConsultaCnpjFechamento = false;
      }
    },
    aplicarReceitaFechamento(receita = {}) {
      this.ganho.nome_correto = receita.nome || this.ganho.nome_correto || "";

      if (receita.email && receita.email.email) {
        this.ganho.email_cliente = receita.email.email;
      }

      if (receita.telefone && receita.telefone.fone) {
        this.ganho.telefone_cliente = receita.telefone.fone;
      }

      if (receita.endereco && receita.endereco.cep) {
        this.ganho.cep = receita.endereco.cep || "";
        this.ganho.logradouro = receita.endereco.logradouro || "";
        this.ganho.numero = receita.endereco.numero || "";
        this.ganho.bairro = receita.endereco.bairro || "";
        this.ganho.complemento = receita.endereco.complemento || "";
        this.ganho.id_cidade = receita.endereco.id_cidade || null;
        this.ganho.cidade =
          receita.endereco.cidade && receita.endereco.cidade.cidade
            ? receita.endereco.cidade.cidade
            : "";
        this.ganho.uf =
          receita.endereco.cidade && receita.endereco.cidade.uf
            ? receita.endereco.cidade.uf
            : "";
        this.ganho.endereco_cliente = this.enderecoFechamentoCompleto(
          this.ganho
        );
      }
    },
    async consultarCepFechamento() {
      if (this.somenteNumeros(this.ganho.cep).length !== 8) {
        this.$toast.warning("Informe um CEP válido para consultar.");
        return;
      }

      this.loadingConsultaCepFechamento = true;

      try {
        const cep = await this.getCep(this.ganho.cep);

        if (!cep || Array.isArray(cep) || cep.erro) {
          this.$toast.warning("Confira o CEP informado.");
          return;
        }

        this.ganho.logradouro = cep.logradouro || "";
        this.ganho.bairro = cep.bairro || "";
        this.ganho.complemento = cep.complemento || "";
        this.ganho.cep = cep.cep || this.ganho.cep;

        const cidade = await this.getCidadeByUF(cep.localidade, cep.uf);
        const cidadeSelecionada = this.primeiraCidadeConsulta(cidade);
        this.ganho.id_cidade = cidadeSelecionada
          ? cidadeSelecionada.id_cidade
          : null;
        this.ganho.cidade = cidadeSelecionada
          ? cidadeSelecionada.cidade
          : cep.localidade || "";
        this.ganho.uf = cidadeSelecionada ? cidadeSelecionada.uf : cep.uf || "";
        this.ganho.endereco_cliente = this.enderecoFechamentoCompleto(
          this.ganho
        );
        this.$toast.success("Endereço carregado pelo CEP.");
      } catch (error) {
        this.$toast.warning(
          this.apiError(error, "Não foi possível consultar o CEP.")
        );
      } finally {
        this.loadingConsultaCepFechamento = false;
      }
    },
    primeiraCidadeConsulta(cidade) {
      return Array.isArray(cidade) ? cidade[0] : cidade;
    },
    enderecoPessoaOportunidade(oportunidade) {
      return {
        cep: oportunidade.pessoa_endereco_cep || "",
        logradouro: oportunidade.pessoa_endereco_logradouro || "",
        numero: oportunidade.pessoa_endereco_numero || "",
        bairro: oportunidade.pessoa_endereco_bairro || "",
        complemento: oportunidade.pessoa_endereco_complemento || "",
        id_cidade: oportunidade.pessoa_endereco_id_cidade || null,
        cidade: oportunidade.pessoa_endereco_cidade || "",
        uf: oportunidade.pessoa_endereco_uf || "",
      };
    },
    validarEnderecoGanho(form) {
      const enderecoTexto = (form.endereco_cliente || "").trim();
      const camposEstruturados = [
        form.cep,
        form.id_cidade,
        form.logradouro,
        form.numero,
        form.bairro,
      ];
      const temCampoEstruturado = camposEstruturados.some((valor) =>
        (valor || "").toString().trim()
      );

      if (!enderecoTexto && !temCampoEstruturado) {
        this.$toast.error("Informe o endereço do cliente.");
        return false;
      }

      if (!temCampoEstruturado && enderecoTexto) {
        return true;
      }

      if (this.somenteNumeros(form.cep).length !== 8) {
        this.$toast.error("Informe um CEP válido.");
        return false;
      }

      if (!form.id_cidade) {
        this.$toast.error("Informe a cidade do cliente pelo CEP.");
        return false;
      }

      if (!(form.logradouro || "").trim()) {
        this.$toast.error("Informe o logradouro do cliente.");
        return false;
      }

      if (!(form.numero || "").trim()) {
        this.$toast.error("Informe o número do endereço do cliente.");
        return false;
      }

      if (!(form.bairro || "").trim()) {
        this.$toast.error("Informe o bairro do cliente.");
        return false;
      }

      return true;
    },
    enderecoFechamentoCompleto(form) {
      const endereco = [
        form.logradouro,
        form.numero ? `nº ${form.numero}` : null,
        form.bairro,
        [form.cidade, form.uf].filter(Boolean).join(" / "),
        form.cep ? `CEP ${form.cep}` : null,
      ]
        .filter(Boolean)
        .join(", ");

      return endereco || form.endereco_cliente || "";
    },
    somenteNumeros(value) {
      return String(value || "").replace(/\D+/g, "");
    },
    formatDateTime(value) {
      return new Date(value).toLocaleString("pt-BR");
    },
    formatTime(value) {
      return new Date(value).toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    toDateTimeLocal(value) {
      if (!value) {
        return null;
      }

      const date = new Date(value);
      date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
      return date.toISOString().slice(0, 16);
    },
    fromDateTimeLocal(value) {
      return value ? value.replace("T", " ") + ":00" : null;
    },
    dateFromDateTimeLocal(value) {
      return value ? value.slice(0, 10) : null;
    },
    apiError(error, fallback) {
      return (
        error?.response?.data?.msg || error?.response?.data?.message || fallback
      );
    },
    responseData(response) {
      const body = response && response.data ? response.data : response;
      return body && body.data ? body.data : body;
    },
    vendedoresFromAtribuicoes(response) {
      return this.usuariosPorPapelFromAtribuicoes(response, "vendedor");
    },
    desenvolvedoresFromAtribuicoes(response) {
      return this.usuariosPorPapelFromAtribuicoes(response, "desenvolvedor");
    },
    usuariosPorPapelFromAtribuicoes(response, papel) {
      const data = this.responseData(response);
      const usuarios =
        data && Array.isArray(data.usuarios) ? data.usuarios : [];

      return usuarios.filter((usuario) => {
        const papeis = Array.isArray(usuario.papeis_crm)
          ? usuario.papeis_crm
          : [];

        return usuario.selecionado || papeis.includes(papel);
      });
    },
    usuarioPorId(idUsuario) {
      const id = Number(idUsuario);
      const listas = [
        this.usuarios,
        this.vendedoresAtribuicao,
        this.desenvolvedoresAtribuicao,
        this.treinamentoAtribuicao,
      ];

      return listas
        .flat()
        .find((usuario) => Number(usuario.id_usuario) === id);
    },
    usuarioPossuiPapelCrm(idUsuario, papel) {
      const usuario = this.usuarioPorId(idUsuario);
      const papeis = Array.isArray(usuario && usuario.papeis_crm)
        ? usuario.papeis_crm
        : [];

      return papeis.includes(papel);
    },
    funilAtualChavePreset() {
      const funil =
        this.funis.find(
          (item) => Number(item.id_crm_funil) === Number(this.funilAtualId)
        ) || (this.kanban ? this.kanban.funil : null);

      return funil ? funil.chave_preset : null;
    },
    usuarioTemAcessoPorPapelAoFunilAtual(idUsuario) {
      const mapa = {
        vendas: ["vendedor", "desenvolvedor"],
        vendas_cliente_final: ["vendedor", "desenvolvedor"],
        pos_venda: ["vendedor"],
        implementacao_white_label: ["desenvolvedor"],
        treinamento_cliente_final: ["treinamento_cliente_final", "treinamento"],
        treinamento: ["treinamento"],
        website: ["website"],
      };
      const papeis = mapa[this.funilAtualChavePreset()] || [];

      return papeis.some((papel) => this.usuarioPossuiPapelCrm(idUsuario, papel));
    },
    isTreinamentoClienteFinal(oportunidade) {
      return (
        oportunidade && oportunidade.tipo_fluxo === "treinamento_cliente_final"
      );
    },
    idPrimeiroResponsavelTreinamento() {
      const primeiro = this.treinamentoResponsavelOptions.find(
        (option) => option.value
      );

      return primeiro ? primeiro.value : null;
    },
  },
};
</script>

<style scoped>
.crm-header-actions,
.crm-filter-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

.crm-filter-actions {
  align-items: center;
}

.crm-filter-actions .btn {
  min-width: 112px;
}

.crm-funnel-toolbar {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
}

.crm-funnel-selector {
  display: grid;
  gap: 4px;
  min-width: 220px;
  width: min(320px, 100%);
}

.crm-funnel-selector label {
  color: #7e8299;
  font-size: 12px;
  font-weight: 800;
  margin: 0;
}

.crm-quick-search {
  display: grid;
  flex: 1 1 320px;
  gap: 4px;
  max-width: 560px;
  min-width: 260px;
}

.crm-quick-search label {
  color: #7e8299;
  font-size: 12px;
  font-weight: 800;
  margin: 0;
}

.crm-quick-search-input {
  align-items: center;
  background: #ffffff;
  border: 1px solid #e4e6ef;
  border-radius: 6px;
  display: flex;
  min-height: 38px;
  padding: 0 8px;
}

.crm-quick-search-input > i {
  color: #7e8299;
  flex: 0 0 auto;
  font-size: 18px;
  margin-right: 6px;
}

.crm-quick-search-input .form-control {
  border: 0;
  box-shadow: none;
  min-width: 0;
  padding-left: 0;
  padding-right: 4px;
}

.crm-quick-search-clear {
  align-items: center;
  background: transparent;
  border: 0;
  color: #7e8299;
  display: inline-flex;
  flex: 0 0 28px;
  height: 28px;
  justify-content: center;
  padding: 0;
}

.crm-quick-search-clear:hover {
  color: #181c32;
}

.crm-filter-bar {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-start;
}

.crm-filter-count {
  align-items: center;
  background: #181c32;
  border-radius: 999px;
  color: #ffffff;
  display: inline-flex;
  font-size: 11px;
  height: 20px;
  justify-content: center;
  margin-left: 6px;
  min-width: 20px;
  padding: 0 6px;
}

.crm-filter-drawer {
  padding: 18px;
}

.crm-stage-preview {
  background: #f8fafc;
  border: 1px solid #e4e6ef;
  border-radius: 6px;
  min-height: 62px;
  padding: 10px 12px;
}

.crm-stage-preview span {
  color: #7e8299;
  display: block;
  font-size: 12px;
  margin-bottom: 4px;
}

.crm-stage-preview strong {
  color: #25324b;
  display: block;
  font-size: 13px;
  overflow-wrap: anywhere;
}

.crm-kanban-shell {
  min-width: 0;
}

.crm-kanban-top-scroll {
  margin: 0 4px 10px;
  min-height: 14px;
  overflow-x: auto;
  overflow-y: hidden;
}

.crm-kanban-scroll-content {
  height: 1px;
}

.crm-kanban {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  padding: 2px 4px 12px;
  scroll-padding: 4px;
  scroll-snap-type: x proximity;
}

.crm-kanban-column {
  background: #f4f7fb;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  flex: 0 0 320px;
  max-height: calc(100vh - 170px);
  min-height: 420px;
  min-width: 0;
  overflow-y: auto;
  padding: 14px;
  scroll-snap-align: start;
  transition: background-color 0.16s ease, border-color 0.16s ease,
    box-shadow 0.16s ease;
}

.crm-kanban-column.is-drop-source {
  background: #eef4fb;
}

.crm-kanban-column.is-drop-target {
  background: #eafaff;
  border-color: #0bb7d4;
  box-shadow: inset 0 0 0 2px rgba(11, 183, 212, 0.18);
}

.crm-kanban-column.is-moving {
  pointer-events: none;
}

.crm-kanban-header {
  align-items: flex-start;
  background: #f4f7fb;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  gap: 10px;
  justify-content: space-between;
  margin: -14px -14px 12px;
  padding: 14px;
  position: sticky;
  top: -14px;
  z-index: 3;
}

.crm-kanban-header > div {
  min-width: 0;
}

.crm-kanban-header strong {
  color: #25324b;
  display: block;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.crm-kanban-value {
  color: #7e8299;
  font-size: 12px;
  margin-top: 4px;
}

.crm-stage-automation {
  color: #0bb7d4;
  display: block;
  font-size: 11px;
  line-height: 1.25;
  margin-top: 3px;
  overflow-wrap: anywhere;
}

.crm-drop-hint {
  align-items: center;
  background: #ffffff;
  border: 1px dashed #0bb7d4;
  border-radius: 8px;
  color: #0b87c9;
  display: flex;
  font-size: 12px;
  font-weight: 800;
  justify-content: center;
  margin-bottom: 10px;
  min-height: 54px;
  padding: 10px;
  text-align: center;
}

.crm-kanban-card {
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  margin-bottom: 10px;
  padding: 12px;
}

.crm-card-title {
  color: #181c32;
  font-weight: 700;
  max-width: 190px;
  overflow-wrap: anywhere;
}

.crm-card-contact {
  overflow-wrap: anywhere;
}

.crm-card-line {
  align-items: center;
  display: flex;
  font-size: 12px;
  justify-content: space-between;
  margin-top: 10px;
}

.crm-card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
}

.crm-next-action {
  background: #f3f6f9;
  border-radius: 4px;
  color: #7e8299;
  font-size: 12px;
  margin-top: 10px;
  padding: 6px 8px;
}

.crm-next-action-late {
  background: #fff5f8;
  color: #f64e60;
}

.crm-kanban-empty {
  color: #7e8299;
  padding: 20px 0;
  text-align: center;
}

.crm-agenda-horarios {
  background: #f8f9fb;
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  margin-bottom: 16px;
  padding: 14px;
}

.crm-agenda-context {
  color: #7e8299;
  display: block;
  font-size: 12px;
  font-weight: 700;
  margin-top: 4px;
}

.crm-agenda-cliente {
  background: #f8f9fb;
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 12px 14px;
}

.crm-agenda-cliente span {
  color: #7e8299;
  font-size: 12px;
}

.crm-agenda-cliente strong {
  color: #3f4254;
}

.crm-agenda-slots {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(auto-fill, minmax(116px, 1fr));
}

.crm-agenda-slot {
  background: #ffffff;
  border: 1px solid #1bc5bd;
  border-radius: 8px;
  color: #3f4254;
  display: flex;
  flex-direction: column;
  min-height: 54px;
  padding: 8px 10px;
  text-align: left;
}

.crm-agenda-slot strong,
.crm-agenda-slot small {
  overflow-wrap: anywhere;
}

.crm-agenda-slot.selected {
  background: #e8fff3;
  border-color: #1bc5bd;
  box-shadow: 0 0 0 2px rgba(27, 197, 189, 0.2);
  color: #181c32;
}

.crm-agenda-slot.selected::after {
  color: #1bc5bd;
  content: "Selecionado";
  font-size: 11px;
  font-weight: 700;
  margin-top: 4px;
}

.crm-agenda-slot small {
  color: #7e8299;
}

.crm-agenda-slot.unavailable {
  background: #f3f6f9;
  border-color: #e4e6ef;
  color: #7e8299;
}

.crm-close-summary {
  background: #f3f6f9;
  border: 1px solid #e4e6ef;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-bottom: 16px;
  padding: 12px;
}

.crm-close-summary span {
  color: #7e8299;
  font-size: 12px;
}

.crm-negotiation-data {
  display: grid;
  gap: 10px;
}

.crm-negotiation-data > div {
  background: #f8fafc;
  border: 1px solid #e4e9f1;
  border-radius: 6px;
  display: grid;
  gap: 3px;
  padding: 10px 12px;
}

.crm-negotiation-data span {
  color: #7e8299;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
}

.crm-negotiation-data strong {
  color: #25324b;
  overflow-wrap: anywhere;
}

.crm-drawer-body {
  padding: 18px;
}

.crm-drawer-footer {
  align-items: center;
  background: #ffffff;
  border-top: 1px solid #e4e9f1;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
  padding: 12px 16px;
}

.crm-drawer-footer .btn {
  white-space: normal;
}

.crm-wizard {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.crm-wizard-steps {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.crm-wizard-step {
  align-items: center;
  background: #f7f9fc;
  border: 1px solid #e4e9f1;
  border-radius: 8px;
  color: #647084;
  display: flex;
  gap: 10px;
  min-height: 44px;
  min-width: 0;
  padding: 9px 10px;
  text-align: left;
}

.crm-wizard-step span {
  align-items: center;
  background: #eaf2fb;
  border-radius: 50%;
  color: #57708b;
  display: inline-flex;
  flex: 0 0 24px;
  font-size: 12px;
  font-weight: 800;
  height: 24px;
  justify-content: center;
}

.crm-wizard-step strong {
  font-size: 12px;
  overflow-wrap: anywhere;
}

.crm-wizard-step.active {
  background: #ecfbff;
  border-color: #0bb7d4;
  color: #143452;
}

.crm-wizard-step.active span,
.crm-wizard-step.done span {
  background: #0bb7d4;
  color: #ffffff;
}

.crm-wizard-step.done {
  background: #f0fbf7;
  border-color: #b9f1dd;
  color: #23463d;
}

.crm-wizard-body {
  display: grid;
  gap: 18px;
  grid-template-columns: minmax(0, 1fr) 310px;
  min-width: 0;
}

.crm-wizard-main,
.crm-wizard-preview {
  background: #ffffff;
  border: 1px solid #e4e9f1;
  border-radius: 8px;
  min-width: 0;
}

.crm-wizard-main {
  min-height: 320px;
  padding: 22px;
}

.crm-wizard-main h3 {
  color: #181c32;
  font-size: 20px;
  font-weight: 800;
  margin-bottom: 4px;
}

.crm-wizard-main p {
  color: #647084;
  margin-bottom: 18px;
}

.crm-wizard-preview {
  align-self: flex-start;
  background: #f7f9fc;
  padding: 14px;
}

.crm-wizard-preview small {
  color: #647084;
  display: block;
  font-weight: 800;
  margin-bottom: 10px;
  text-transform: uppercase;
}

.crm-wizard-preview .crm-deal-card {
  margin-bottom: 0;
}

.crm-wizard-summary {
  display: grid;
  gap: 10px;
}

.crm-wizard-summary div {
  background: #f7f9fc;
  border: 1px solid #e4e9f1;
  border-radius: 8px;
  display: flex;
  gap: 10px;
  justify-content: space-between;
  padding: 12px 14px;
}

.crm-wizard-summary span {
  color: #647084;
}

.crm-wizard-summary strong {
  color: #25324b;
  max-width: 55%;
  overflow-wrap: anywhere;
  text-align: right;
}

.crm-wizard-footer {
  align-items: center;
  border-top: 1px solid #edf1f7;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding-top: 16px;
}

.crm-wizard-footer > div {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

.crm-wizard-footer .btn {
  white-space: normal;
}

.crm-temperature-grid {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.crm-temperature-option {
  align-items: center;
  background: #ffffff;
  border: 1px solid #dfe5ee;
  border-left: 4px solid var(--temperature-color, #7e8299);
  border-radius: 8px;
  color: #25324b;
  display: flex;
  gap: 10px;
  min-height: 44px;
  min-width: 0;
  padding: 10px 12px;
  text-align: left;
}

.crm-temperature-option i {
  color: var(--temperature-color, #7e8299);
  font-size: 18px;
}

.crm-temperature-option span {
  font-weight: 800;
  min-width: 0;
  overflow-wrap: anywhere;
}

.crm-temperature-option:hover,
.crm-temperature-option:focus {
  border-color: var(--temperature-color, #0bb7d4);
  box-shadow: 0 0 0 3px rgba(11, 183, 212, 0.12);
  outline: none;
}

.crm-temperature-option.active {
  background: #f7fcff;
  border-color: var(--temperature-color, #0bb7d4);
  box-shadow: inset 0 0 0 1px var(--temperature-color, #0bb7d4);
}

.crm-benefit-suggestions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.crm-benefit-chip {
  background: #eaf6ff;
  border: 1px solid #cfe9ff;
  border-radius: 6px;
  color: #1f5f93;
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
  padding: 8px 10px;
}

.crm-benefit-chip:hover,
.crm-benefit-chip:focus {
  background: #dff2ff;
  border-color: #9fd5ff;
  outline: none;
}

.crm-benefit-chip.active {
  background: #0bb7d4;
  border-color: #0aa4bf;
  color: #ffffff;
}

@media (max-width: 991px) {
  .crm-kanban-column {
    flex-basis: 300px;
    max-height: calc(100vh - 210px);
  }

  .crm-wizard-body {
    grid-template-columns: minmax(0, 1fr);
  }

  .crm-wizard-preview {
    align-self: stretch;
  }
}

@media (max-width: 767px) {
  .crm-header-actions {
    justify-content: flex-start;
    margin-top: 12px;
  }

  .crm-filter-actions {
    justify-content: flex-start;
  }

  .crm-kanban-column {
    flex-basis: 286px;
    max-height: none;
    min-height: 360px;
  }

  .crm-wizard-steps {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .crm-wizard-footer {
    align-items: stretch;
    flex-direction: column;
  }

  .crm-wizard-footer > div {
    justify-content: flex-start;
  }
}

@media (max-width: 575px) {
  .crm-quick-search {
    flex-basis: 100%;
    min-width: 0;
  }

  .crm-filter-actions .btn,
  .crm-drawer-footer .btn,
  .crm-wizard-footer .btn {
    flex: 1 1 100%;
  }

  .crm-kanban {
    gap: 12px;
  }

  .crm-kanban-column {
    flex-basis: min(286px, calc(100vw - 48px));
  }

  .crm-wizard-main {
    padding: 16px;
  }

  .crm-wizard-summary div {
    align-items: flex-start;
    flex-direction: column;
  }

  .crm-wizard-summary strong {
    max-width: 100%;
    text-align: left;
  }
}
</style>
